import { invalid } from 'moment';
import { exportCSV } from '../common/utils';

const pt = {
  translation: {
    formats: {
      date: 'DD/MM/YYYY',
    },
    self: {
      title: 'CASSIE',
      fullTitle: 'Coastal Analyst System from Space Imagery Engine',
      shortDesc:
        'Plataforma web colaborativa com soluções de observações e previsões geoespaciais aplicadas à monitoramento, mitigação e adaptação da zona costeira face às mudanças do clima.',
      abstract:
        'O objetivo geral deste projeto é definir metodologia técnica e operacional e desenvolver uma plataforma web que disponibilize serviço de informação derivada de satélite e inteligência artificial (e.g. linha de costa, topografia, batimetria, compressão costeira, hidrodinâmica) para criação de acervo aplicados à mitigação e adaptação da zona costeira a mudanças do clima.',
      poweredBy: 'Powered by: Google Earth Engine',
      imageryProvider: 'Fontes das imagens dos satélites: NASA (Landsat) e ESA (Sentinel)',
      code: 'CASSIE',
      name: 'Coastal Analyst System from Space Imagery Engine',
      changeLanguage: 'Idioma',
    },
    home: {
      about: {
        title: 'Conheça mais sobre o CASSIE',
      },
      instructions: {
        title: 'Instruções para utilização do CASSIE',
        text: 'Para utilizar o CASSIE é necessário possuir uma conta google cadastrada na plataforma google earth engine.',
        btnEngineSingUp: 'Primeiro Acesso',
        btnManual: 'Manual do Usuário',
        linkManual: 'https://drive.google.com/file/d/1jr5k0Msgvuy-qMryFDxHRLo3_jiDQ2Vd/view?usp=sharing',
        btnVideo: 'Video Demonstrativo',
        linkVideo: 'https://www.youtube.com/@CASSIE-Core',
      },
      baysqueeze: {
        title: 'BaySqueeze',
        text: 'O projeto procura contribuir com ações e resultados para o bem e preservação do nosso planeta, tomando para si, a tarefa de cumprir os objetivos de desenvolvimento sustentável, estabelecidos pela ONU, bem como atender às necessidades nacionais de conhecimento sobre mudanças climáticas, paralelamente aos objetivos da sub-rede "Zonas Costeiras", da Rede Brasileira de Pesquisas sobre Mudanças Climáticas Globais(Rede Clima).',
        btn: 'Mais sobre o projeto',
      },
      riscport: {
        title: 'RiskPorts',
        text: 'Este projeto tem como objetivo principal realizar uma análise dos riscos climáticos (ambientais e econômicos) e determinar as possíveis medidas de adaptação, como base na projeção futura das ameaças ambientais (ex: ondas de tempestades), para incrementar a resiliência do setor portuário e áreas adjacentes na Baía da Babitonga, em um contexto de uma rede interdisciplinar e multi-institucional.',
        btn: 'Mais sobre o projeto',
      },
      members: {
        title: 'Equipe',
        roles: {
          researcher: 'Pesquisador',
          coord: 'Coordenador',
          coord_geral: 'Coordenador Geral',
          atp: 'Bolsista ATP-B',
          bolsista: 'Bolsista - Desenvolvimento',
          validacao: 'Validação',
          desenvolvimento: 'Desenvolvimento',
          fumdes: 'Bolsista FUMDES',
          capes: 'Bolsista CAPES DTI-A',
        },
        links: {
          teamDescription: 'A Equipe',
          currentTeam: 'Equipe Atual',
          teamHistory: 'Histórico da Equipe',
        },
      },
      papers: {
        title: 'Produção científica',
        resumo_text: 'Resumo em Evento',
        paper_text: 'Artigo em Revista',
        curso_text: 'Curso',
        more: 'Saiba Mais',
      },
      sponsor: {
        realiza: 'Realização',
        apoio: 'Apoio Financeiro',
        apoio_desc:
          'Atual Processo No. 406603/2022-7. Anteriores: Processo No. 441818/2020-0, CNPq MCTIC/CNPq - N° 21/2017; Processo No. 441545/2017-3.',
        inst: 'Apoio Institucional',
        partners: 'Parceiros',
        previousSections: {
          institutionalCurrent: 'Parceiros Institucionais Atuais',
          closedPartnerships: 'Parcerias Encerradas',
        },
      },
      footer: {
        social: 'Social',
        copyright: 'Todos os direitos reservados. Desenvolvido por',
        help: {
          title: 'Ajuda e Suporte',
          faq: 'Perguntas Frequentes',
          discussion: 'Fórum de Discussões',
          problems: 'Problemas Conhecidos',
          termsOfUse: 'Termos de Uso',
          termsOfUseText:
            'O código do CASSIE é público, aberto e gratuito, sendo disponibilizado através da licença Creative Commons CC-BY-SA, mediante a referência da fonte de acordo com o seguinte formato: CASSIE - acessado em [data] através do link: https://cassiengine.org/',
        },
        contact: {
          title: 'Contato',
          manage: 'Coordenação do projeto',
          techquest: 'Dúvidas Técnicas',
        },
        resources: {
          title: 'Recursos',
          code: 'Código Fonte',
          license: 'Licença',
        },
      },
      warning: {
        text: 'O CASSIE ainda está em desenvolvimento.',
        link: 'Saiba mais',
      },
      cookies: {
        text: 'Nosso site usa cookies para melhorar a navegação.',
        link: 'Aceitar',
      },
      cards: {
        projectSite: {
          title: 'Site do Projeto',
          description: 'Visite o site principal do projeto e conheça mais sobre nossas iniciativas.',
          button: 'Acessar',
        },
        survey: {
          title: 'Pesquisa de Satisfação',
          description: 'Participe da nossa pesquisa de satisfação e nos ajude a melhorar.',
          button: 'Acessar',
        },
        tool: {
          title: 'Ferramenta CASSIE',
          description: 'Acesse a ferramenta CASSIE para explorar nossas funcionalidades em sensoriamento remoto.',
          button: 'Acessar',
        },
      },
    },

    faq: {
      title: 'Perguntas Frequentes',
      0: {
        title: 'Como o CASSIE Funciona?',
        text: 'O CASSIE utiliza do Google Earth Engine (GEE), uma plataforma de processamento paralelo em nuvem de dados geospaciais (<a href="https://www.sciencedirect.com/science/article/pii/S0034425717302900" target="_blank">Gorelick et al., 2017</a>). O CASSIE se comunica com o GEE por meio de uma API (Application Programming Interface - Interface de Programação de Aplicativos), que o permite utilizar dos datasets e do potencial de processamento do GEE.',
      },
      1: {
        title: 'Quais datasets de imagem satélite estão disponíveis no CASSIE?',
        text: 'Atualmente, o CASSIE possibilita análises com dados do <a href="https://developers.google.com/earth-engine/datasets/catalog/COPERNICUS_S2" target="_blank">Sentinel 2 (MSI, TOA) Level-1C</a> e com a coleção dos Landsats (<a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LT05_C01_T1_SR" target="_blank">Landsat 5 TM SR Tier 1</a>,<a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LE07_C01_T1_SR" target="_blank">Landsat 7 ETM+ SR Tier 1</a>, <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LC08_C01_T1_SR" target="_blank">Landsat 8 OLI SR Tier 1</a>). Quando não há imagens disponíveis de Tier 1 (maior qualidade) para o Landsat 7 e 8, o CASSIE utiliza de imagens das coleções <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LE07_C01_T2_TOA" target="_blank">Landsat 7 TOA Tier 2</a> e <a href="https://developers.google.com/earth-engine/datasets/catalog/LANDSAT_LC08_C01_T2_TOA" target="_blank">Landsat 8 TOA Tier 2</a>.',
      },
      2: {
        title: 'Como acesso o CASSIE?',
        text: 'O CASSIE está disponível como uma ferramenta open source (código aberto), disponível <a href="http://cassie-stable.herokuapp.com/">neste link</a>. O usuário precisa de uma <a href="https://myaccount.google.com">conta Google</a> registrada (e aprovada) na <a href="https://signup.earthengine.google.com">plataforma Google Earth Engine</a>. O código do CASSIE está disponível no <a href="https://github.com/lia-univali/cassie">Github do LIA - Univali</a>.',
      },
      3: {
        title: 'Ao entrar com a conta da Google, a página fica carregando indefinidamente',
        text: 'Para acessar e utilizar o CASSIE, a conta do usuário deve estar registrada na plataforma Google Earth Engine (GEE). O cadastro pode ser feito por meio deste <a href="https://earthengine.google.com/signup/" target="_blank">link</a>. Assim que o cadastro for confirmado, o utilizador pode acessar e entrar no CASSIE com a sua conta Google.',
      },
      4: {
        title: 'Minha conta é registrada no GEE mas não consigo acessar a ferramenta',
        text: 'O registro na plataforma Google Earth Engine é finalizado com uma confirmação recebida por e-mail. Em alguns casos, o e-mail de confirmação é recebido instantaneamente após o cadastro ser feito. Entretanto, nem sempre a confirmação é instantanea e pode levar um tempo que a equipe do CASSIE não tem controle sobre. Se o utilizador realizou o cadastro e ainda não recebeu o e-mail de confirmação e considera que o tempo de aguardo não é normal, deve entrar em contato com a <a href="https://developers.google.com/earth-engine/help">equipe do Google Earth Engine</a>. Assim que o cadastro for confirmado com o recebimento do e-mail, o utilizador já pode utilizar o CASSIE. Caso o usuário não consiga entrar mesmo após a confirmação, recomenda-se a <a href="https://support.google.com/accounts/answer/32050?co=GENIE.Platform%3DDesktop&hl=pt-BR" target="_blank">limpeza dos cookies do navegador.</a>',
      },
    },
    problems: {
      title: 'Problemas Conhecidos',
      text: 'O CASSIE ainda está em desenvolvimento, alguns processos podem falhar. Esses são alguns problemas conhecidos.',
      0: {
        title: 'Análise de muitos dados',
        text: 'O CASSIE por vezes não é capaz de realizar grandes análises, com região muito grande ou com muitas imagens.',
      },
    },
    general: {
      loading: 'Carregando...',
      cancel: 'Cancelar',
      reset: 'Resetar',
      next: 'Avançar',
      back: 'Voltar',
      geeAccessError:
        'Sua conta ainda não está autorizada a usar a API do GEE. Você deve concluir seu cadastro usando este link: https://earthengine.google.com/signup/',
    },
    auth: {
      signin: 'Acessar Ferramenta com o Google',
      signout: 'Sair',
      loading: 'Autenticando...',
    },
    color: {
      colorRed: 'Vermelho',
      colorGreen: 'Verde',
    },
    tour: {
      done: 'Concluido',
      of: 'de',
      help: 'Ajuda',
      acquisition: {
        1: {
          info: 'Nesta Etapa você deve escolher o Satélite',
          'Sentinel-2': {
            info: 'O Sentinel possui maior resolução espacial e menos tempo de aquisição de dados (de 2013-2025)',
          },
          Landsat: {
            info: 'O Landsat possui menor resolução espacial e mais tempo de aquisição de dados(de 1984 a 2025)',
          },
        },
        2: {
          info: 'Selecione a área de interesse para a análise',
          dataTraining: 'Importe arquivo de dados de treinamento (.csv)',
        },
        3: {
          period: 'Selecione um intervalo de datas para serem analizadas',
          point: 'Cada Ponto rosa é uma imagem',
          cloud: 'Selecione um percentual aceitável de núvens na imagem',
        },
        4: {
          id: 'O ID contém informações importantes como a data e hora em que a imagem foi capturada',
          clouds: 'Nesta coluna temos percentual calculado de Nuvens na imagem',
          image: 'Nesta coluna é apresentada a imagem em questão',
          action: 'Nesta última coluna, você pode escolher se deseja ou não incluir esta imagem na análise',
        },
      },
      bathymetry: {
        exportCSVBathymetry: 'Exportar CSV - Batimetria',
        exportCSVMetrics: 'Exportar CSV - Métricas',
      },
      csqueeze: {
        2: {
          info: '',
          aoi: 'Selecione a área de interesse para a analise',
          mangrove:
            'Neste botão é possível visualizar possíveis áreas de intermarés pelo mundo usando a coleção Murray et al. (2022)',
          importKml: 'Também é possível importar dados de um arquivo KML para desenhar a área de interesse no mapa.',
        },
        3: {
          info: '',
          years: 'Defina dois diferentes anos para gerar o estudo de previsão',
        },
        4: {
          info: '',
          years: 'Para cada ano deve-se escolher imagens com o menor número de nuvens possível',
          timeselector: 'Os pontos rosas representam imagens disponíveis no ano com o filtro de nuvem selecionado',
          viewImageButton:
            'Ao selecionar o ponto rosa com a imagem disponível é necessário clicar aqui para visualizar. Caso não aconteça nada é possível que a imagem está 100% coberta de nuvens, isso ocorre pois o nível de nuvens é definido pela coleção de satélite e nem todas as regiões são precisas.',
          cloudselector:
            'Nesta seleção é possível definir a porcentagem de nuvens nas imagens. Ao mudar esse parâmetro a barra com os pontos rosas será atualizada deixando disponível apenas imagens que se encaixem no valor',
          tableImages:
            'As imagens selecionadas serão mostradas nesta tabela. É necessário selecionar no mínimo 1 de cada ano para ir para a próxima etapa.',
        },
        5: {
          info: '',
          selectType:
            'Selecione um dos tipos para ativar o modo de desenho. Ao escolher a cobertura de solo, clique no mapa para iniciar o desenho de um retângulo na região que representa esse tipo. \n Para apagar o retângulo, segure CTRL e clique nele ou ative o "Remover polígono" e clique sobre o polígono. (É necessário desenhar pelo menos 1 polígono de manguezal e outro distinto para continuar).',
          falseColorButton:
            'Caso a imagem não tenha uma boa nitidez, é possível ativar a máscara de cor falsa que usa a banda de infravermelho ao invés da banda vermelha no mapa.',
          availableDataset:
            'Datasets são coleções prontas mapeadas por usuarios ou organizações com dados prontos. Se o ano desejado possuir um dataset disponível, será avisado no canto da tela a possibilidade de aplicação dele.',
          importPolygons:
            'Também é possível importar retângulos com um arquivo CSV que é gerado pelo botão EXPORTAR logo abaixo.',
          generateRaster:
            'Exportar e limpar todos os retângulos são algumas das opções disponíveis. Caso já tenha desenhado ao menos 1 retângulo de manguezal e outro distinto, o botão "GERAR RASTER" aparecerá.',
          yearsButtons: 'Não esqueça de gerar os raster dos dois anos para poder continuar.',
        },
      },
      euscoast: {
        2: {
          info: '',
          aoi: 'Selecione a área de interesse para a analise',
          importKml: 'Também é possível importar dados de um arquivo KML para desenhar a área de interesse no mapa.',
        },
        3: {
          info: '',
          years: 'Defina dois diferentes anos para gerar o estudo de previsão',
        },
        4: {
          info: '',
          years: 'Para cada ano deve-se escolher imagens com o menor número de nuvens possível',
          timeselector: 'Os pontos rosas representam imagens disponíveis no ano com o filtro de nuvem selecionado',
          viewImageButton:
            'Ao selecionar o ponto rosa com a imagem disponível é necessário clicar aqui para visualizar. Caso não aconteça nada é possível que a imagem está 100% coberta de nuvens, isso ocorre pois o nível de nuvens é definido pela coleção de satélite e nem todas as regiões são precisas.',
          cloudselector:
            'Nesta seleção é possível definir a porcentagem de nuvens nas imagens. Ao mudar esse parâmetro a barra com os pontos rosas será atualizada deixando disponível apenas imagens que se encaixem no valor',
          tableImages:
            'As imagens selecionadas serão mostradas nesta tabela. É necessário selecionar no mínimo 1 de cada ano para ir para a próxima etapa.',
        },
        5: {
          info: '',
          selectType:
            'Selecione um dos tipos para ativar o modo de desenho. Ao escolher a cobertura de solo, clique no mapa para iniciar o desenho de um retângulo na região que representa esse tipo. \n Para apagar o retângulo, segure CTRL e clique nele ou ative o "Remover polígono" e clique sobre o polígono. (É necessário desenhar pelo menos 1 polígono de manguezal e outro distinto para continuar).',
          falseColorButton:
            'Caso a imagem não tenha uma boa nitidez, é possível ativar a máscara de cor falsa que usa a banda de infravermelho ao invés da banda vermelha no mapa.',
          availableDataset:
            'Datasets são coleções prontas mapeadas por usuarios ou organizações com dados prontos. Se o ano desejado possuir um dataset disponível, será avisado no canto da tela a possibilidade de aplicação dele.',
          importPolygons:
            'Também é possível importar retângulos com um arquivo CSV que é gerado pelo botão EXPORTAR logo abaixo.',
          generateRaster:
            'Exportar e limpar todos os retângulos são algumas das opções disponíveis. Caso já tenha desenhado ao menos 1 retângulo de manguezal e outro distinto, o botão "GERAR RASTER" aparecerá.',
          yearsButtons: 'Não esqueça de gerar os raster dos dois anos para poder continuar.',
        },
      },
      interdial: {
        2: {
          info: '',
          aoi: 'Selecione a área de interesse para a analise',
          interdialZone: 'Neste botão é possível visualizar possíveis áreas de intermaré pelo mundo',
          importKml: 'Também é possível importar dados de um arquivo KML para desenhar a área de interesse no mapa.',
        },
      },
      map: {
        start: 'Esta é a tela de processamento',
        imageChooser: {
          info: 'Neste Campo você pode carregar no mapa uma das imagens selecionadas',
          select: 'Por padrão, a imagem selecionada é a mais recente, mas você pode escolher outra clicando aqui',
          click: 'Após selecionar a Imagem, você pode carregá-la na tela apertando neste botão',
        },
      },
    },
    forms: {
      core: {
        pdfReport: {
          failed: 'Não foi possível gerar o relatório em PDF.',
          tooltip:
            'Baixar um relatório em PDF com toda a análise: área, imagens, resultados e mapa num documento só',
          subtitle: 'CASSIE · gerado em {{date}}',
          missingImage: 'A imagem "{{caption}}" não pôde ser incluída: o navegador não liberou o arquivo.',
          screenCaption: 'Tela do resultado, como exibida na análise',
          transectComplete: 'Todos os {{total}} transectos estão listados.',
          transectTruncated:
            'Listados os {{shown}} primeiros de {{total}} transectos. O resumo acima cobre todos; a listagem serve para conferência.',
          forecastYears: '{{years}} anos',
          common: {
            footer: 'CASSIE · Coastal Analysis via Satellite Imagery Engine',
            areaHeading: 'Área de estudo',
            areaFile: 'Arquivo da área',
            areaExtent: 'Extensão (lon, lat)',
            crs: 'Sistema de coordenadas',
            baselineVertices: 'Vértices da linha-base',
            baselineExtent: 'Extensão da linha-base',
            imageryHeading: 'Imagens',
            satellite: 'Satélite',
            imageCount: 'Imagens usadas',
            imageList: 'Datas',
            coastlines: 'Linhas de costa extraídas',
            resultHeading: 'Resultado',
            transectCount: 'Transectos',
            measuredPeriod: 'Período medido',
            resultNote:
              'As taxas são por transecto. LRR vem da regressão linear, EPR do ponto final; valores negativos indicam erosão.',
            classHeading: 'Classificação',
            classNote: 'Classificação de Esteves, aplicada à taxa LRR de cada transecto.',
            transectHeading: 'Transectos',
            mapsHeading: 'Mapa',
          },
          rates: {
            columns: { statistic: 'Estatística', mean: 'Média', min: 'Mínimo', max: 'Máximo', count: 'n' },
            names: {
              lrr: 'LRR (m/ano)',
              epr: 'EPR (m/ano)',
              nsm: 'NSM (m)',
              sce: 'SCE (m)',
              rsquared: 'R² da regressão',
            },
          },
          classes: { columns: { className: 'Classe', count: 'Transectos', share: 'Proporção' } },
          transects: {
            columns: {
              id: 'Transecto',
              lrr: 'LRR',
              epr: 'EPR',
              nsm: 'NSM',
              sce: 'SCE',
              rsquared: 'R²',
              className: 'Classe',
            },
          },
          esteves: {
            Stable: 'Estável',
            Accreted: 'Acreção',
            Eroded: 'Erosão',
            'Critically Eroded': 'Erosão crítica',
          },
          shoreline: { text: { title: 'Relatório de Evolução da Linha de Costa' } },
          shore_r: { text: { title: 'Relatório Shore-R' } },
          shore_s: {
            text: {
              title: 'Relatório Shore-S',
              errorHeading: 'Erro do modelo',
              errorNote:
                'Cada número mede um recorte diferente: a média cobre todas as observações pareadas, os últimos 6 meses cobrem o fim da série, e o final cobre só a última data.',
              modeledCount: 'Linhas modeladas',
              referenceCount: 'Linhas de referência',
              pairedObservations: 'Observações pareadas',
              byDateHeading: 'Erro ao longo do tempo',
              byDateNote: 'Mostra se o modelo se degrada conforme avança, em vez de errar por igual.',
              byTransectHeading: 'Erro por transecto',
              byTransectNote: 'Localiza um ajuste ruim num trecho de costa em vez de espalhá-lo pela análise.',
            },
          },
          errors: {
            rmseAvg: 'RMSE médio (m)',
            biasAvg: 'Viés médio (m)',
            rmseLast6m: 'RMSE dos últimos 6 meses (m)',
            rmseFinal: 'RMSE na data final (m)',
            biasFinal: 'Viés na data final (m)',
            rmsm: 'RMS medido (m)',
            biasm: 'Viés medido (m)',
            bss: 'Brier Skill Score',
          },
          byDate: { columns: { date: 'Data', rms: 'RMS (m)', bias: 'Viés (m)' } },
          byTransect: { columns: { transect: 'Transecto', rms: 'RMS (m)', bias: 'Viés (m)' } },
          mepbay: {
            text: {
              title: 'Relatório MEPBAY',
              imageDate: 'Data da imagem',
              bayCount: 'Enseadas analisadas',
              fitHeading: 'Ajuste parabólico',
              fitNote:
                'Coeficientes da forma de equilíbrio parabólica ajustada a cada enseada, com o ângulo β em que o ajuste se apoia.',
              controlHeading: 'Pontos de controle',
              controlNote: 'Os três pontos que definiram cada curva, na ordem em que são marcados.',
            },
          },
          bays: {
            columns: {
              bay: 'Enseada',
              beta: 'β (graus)',
              cosBeta: 'cos β',
              c0: 'C0',
              c1: 'C1',
              c2: 'C2',
              r0: 'R0 (m)',
            },
          },
          controlPoints: {
            columns: { bay: 'Enseada', point: 'Ponto', longitude: 'Longitude', latitude: 'Latitude' },
            names: {
              diffractionPoint: 'Ponto de difração',
              coastalControlPoint: 'Ponto de fechamento',
              predominantWavePoint: 'Ponto de tangência',
            },
          },
          intertidal: {
            text: {
              title: 'Relatório de Zona de Intermarés',
              tideFile: 'Arquivo de maré',
              waterlineHeading: 'Linhas d\'água',
              waterlineCount: 'Linhas d\'água',
              withTideCount: 'Com nível de maré',
              tideRange: 'Faixa de maré',
              tideSpan: 'Intervalo vertical',
              waterlineNote:
                'Cada linha d\'água é pareada com o nível de maré do instante da imagem. O modelo de elevação é interpolado dentro do intervalo coberto; fora dele é extrapolação.',
              tableHeading: 'Linhas d\'água e marés',
            },
            missingTideNote:
              '{{missing}} linha(s) d\'água sem nível de maré. Elas não entram no modelo de elevação.',
            tideRangeValue: '{{low}} m a {{high}} m',
            tideSpanValue: '{{span}} m',
          },
          waterlines: { columns: { date: 'Data', tide: 'Maré (m)' } },
          csqueeze: {
            text: {
              title: 'Relatório de Coastal Squeeze',
              sourceHeading: 'Cobertura do solo',
              collection: 'Coleção',
              periodCount: 'Períodos',
              periodList: 'Períodos analisados',
              forecast: 'Projeção',
              coverHeading: 'Área por cobertura e período',
              coverNote: 'Somada sobre todos os transectos. O detalhe por transecto está na exportação em CSV.',
              classHeading: 'Classificação de squeeze',
              classNote: 'Quantos transectos têm o habitat costeiro encurralado e quantos ainda têm para onde recuar.',
              transectHeading: 'Transectos',
            },
          },
          euscoast: {
            text: {
              title: 'Relatório EUSCoast',
              sourceHeading: 'Cobertura do solo',
              collection: 'Coleção',
              periodCount: 'Períodos',
              periodList: 'Períodos analisados',
              forecast: 'Projeção',
              coverHeading: 'Área por cobertura e período',
              coverNote: 'Somada sobre todos os transectos. O detalhe por transecto está na exportação em CSV.',
              classHeading: 'Classificação de squeeze',
              classNote: 'Quantos transectos têm o habitat costeiro encurralado e quantos ainda têm para onde recuar.',
              transectHeading: 'Transectos',
            },
          },
          cover: { columns: { period: 'Período' } },
        },
        loading: {
          kml: 'Lendo o arquivo KML…',
          area: 'Preparando a área selecionada…',
          cloudCoverage: 'Verificando a cobertura de nuvens da área…',
          searchingImages: 'Procurando imagens disponíveis…',
          images: 'Carregando as imagens…',
          years: 'Buscando os anos com imagens…',
          composite: 'Gerando a imagem composta…',
          trainingData: 'Lendo os dados de treinamento…',
          charts: 'Recalculando os gráficos…',
          chartsProgress: 'Amostrando os pontos de treino: {{done}} de {{total}} partes…',
          model: 'Lendo o modelo enviado…',
          map: 'Preparando o mapa…',
          result: 'Montando o resultado…',
          depth: 'Calculando a batimetria…',
          waterlines: 'Carregando as linhas d\'água…',
          zones: 'Calculando as zonas de intermarés…',
          export: 'Preparando o arquivo para download…',
          depthZones: 'Vetorizando a profundidade em faixas…',
        },
        sessionHistory: {
          button: 'Análises salvas',
          title: 'Análises salvas neste navegador',
          empty: 'Nenhuma análise salva ainda.',
          unnamed: 'Análise sem nome',
          opening: 'Abrindo a análise salva…',
          missing: 'Esta análise não está mais salva neste navegador.',
          remove: 'Remover do histórico',
          close: 'Fechar',
        },
        fileErrors: {
          selectFileFirst: 'Selecione um arquivo primeiro.',
          kmlNoCoordinates: 'Nenhuma coordenada válida foi encontrada no arquivo KML.',
          unreadableFile: 'Não foi possível interpretar o arquivo selecionado.',
          missingCoordinateSystem: 'Informe o sistema de coordenadas.',
          missingTrainingFile: 'Selecione o arquivo com os dados de treinamento.',
          missingDate: 'Informe a data antes de continuar.',
        },
        screenshot: {
          button: 'Salvar imagem da tela (PNG)',
          error: 'Não foi possível gerar a imagem da tela.',
        },
        overlayPanels: {
          hide: 'Ocultar painéis',
          show: 'Mostrar painéis',
        },
        workflowStepper: {
          blocked: 'Conclua as etapas anteriores para abrir esta',
        },
        stepSummary: {
          label: 'Resumo da aquisição',
          area: 'Área definida',
          images: {
            singular: '{{total}} imagem',
            plural: '{{total}} imagens',
          },
          periods: {
            singular: '{{total}} período',
            plural: '{{total}} períodos',
          },
        },
        returnButtons: {
          returnToLastStep: 'Voltar para a última etapa',
          returnToBegin: 'Voltar à seleção de módulos',
        },
      },
      intertidal: {
        moduleName: 'Intermaré',
        analysesTitle: 'Desvio Padrão da banda {{index}}',
        useAnalysis: 'Usar',
        usingAnalysis: 'Usando',
        selected: 'Selecionado',
        threshold: 'Limiar',
        aweiLayers: 'camadas {{index}}',
        chooseIndexTitle: 'Escolha do índice',
        zoneIndexLabel: 'Índice da zona',
        waterlineIndexLabel: 'Índice da linha de costa',
        createRaster: 'Criar',
        selectAnalysisRequired: 'Por favor, selecione uma análise antes de continuar.',
        editAnalysis: 'Editar limiar',
        deleteAnalysisConfirm: 'Deseja excluir "{{name}}"?',
        noVectorsFound: 'Nenhum vetor encontrado.',
        deleteAllPolygonsConfirm: 'Você está prestes a deletar todos os polígonos. Continuar?',
        indexAwei: 'AWEI',
        indexNdwi: 'NDWI',
        indexMndwi: 'MNDWI',
        indexMndwiSharp: 'MNDWI (realçado)',
        hideAnalysis: 'Ocultar análise',
        showAnalysis: 'Mostrar análise',
        title: 'Intermarés',
        prev: 'Voltar',
        next: 'Continuar',
        exportData: 'Exportar dados',
        confirm: 'Confirmar',
        year: 'Ano',
        years: 'anos',
        timezone: 'Fuso horário',
        selectValue: 'Selecione um valor...',
        startDateMandatory: 'Data inicial obrigatória.',
        importTideDataFile: 'Selecione o arquivo de maré para importar.',
        dataFormat: 'Formato dos dados',
        downloadSampleTideData: 'Clique para baixar arquivo de exemplo.',
        column1: 'datetime',
        column2: 'tideData',
        doubleValue: 'Double value',
        endDateMandatory: 'Data final obrigatória.',
        endDateAfterStartDate: 'Data final precisa ser posterior a data inicial.',
        zoneOnlyLabel: 'Gerar apenas a área intermaré',
        zoneOnlyDescription:
          'A delimitação da área intermaré não depende dos dados de maré, apenas a reconstrução topográfica final. Ativando essa opção, os dados de maré ficam opcionais e as etapas de extração de linhas de costa e interpolação Kriging não são executadas.',
        optionalField: 'Opcional',
        zoneOnlyResultNotice:
          'Modo "apenas área intermaré" ativo: apenas a área intermaré foi delimitada, sem extração de linhas de costa nem interpolação Kriging. Para baixar o raster da zona, volte ao passo 4 e use "Download das imagens".',
        tideDataPeriodMismatchTitle: 'Dados de maré incompatíveis com o período',
        tideDataPeriodMismatchMessage:
          'O arquivo de maré importado cobre o período de {{tideMin}} a {{tideMax}}, que não tem sobreposição com o período de análise selecionado ({{periodStart}} a {{periodEnd}}). Ajuste o período de análise ou importe um arquivo de maré compatível antes de continuar.',
        tideFileTooLarge: 'O arquivo é muito grande ({{size}} MB). O limite é de 5 MB.',
        readFileTide: 'Por favor, selecione o arquivo primeiro.',
        lineTideFileErrorPartA: 'Problema com linha no arquivo de dados de maré:',
        lineTideFileErrorPartB: '- não contém o formato adequado.',
        mapnotready: 'O mapa ainda não está pronto!',
        kmlFileProcessed: 'Arquivo KML processado.',
        tileDataProcessed: 'Dados de maré processados!',
        geeAccessError: 'Erro ao acessar Google Earth Engine',
        kmlNoCoordinates: 'Não foram encontradas coordenadas válidas no arquivo KML.',
        interpretFileError: 'Não foi possível interpretar o arquivo selecionado.',
        cloudFilterMandatory: 'Filtro de nuvens obrigatório.',
        attributes: {
          dateTime: 'Data-Horário',
          tideValue: 'Nível da Maré',
          dateImage: 'Data da Imagem',
          dateGauge: 'Data do Marégrafo',
          noProperties: 'Sem propriedades',
        },
        downloadVectors: 'DOWNLOAD DA ÁREA (SHAPEFILE)',
        downloadImages: 'DOWNLOAD DAS IMAGENS (RASTER)',
        aweiZone: 'Banda {{index}}',
        waterlines: 'Linhas',
        layer: 'Camada',
        legend: 'Legenda',
        vectorEditor: 'Editor de Vetores - Revise e Limpe as Zonas Detectadas',
        clickPolygons: 'Clique nos polígonos para marcar/desmarcar para deleção',
        deletedCount: '{{count}} polígono(s) marcado(s) para deleção (vermelho)',
        noneDeleted: 'Nenhum polígono marcado para deleção',
        skip: 'Pular Edição',
        description: 'Revise e edite as zonas intermarés detectadas removendo polígonos indesejados',
        samplingInterval: 'Intervalo de Amostragem',
        generateKriging: 'Gerar Interpolação Kriging',
        processingKriging: 'Processando interpolação...',
        downloadKriging: 'Baixar Resultado Kriging',
        krigingLegend: 'Nível de Maré (m)',
        krigingInterpolation: 'Interpolação Kriging',
        krigingStats: 'Estatísticas da Interpolação',
        krigingPrepare: 'Preparar Interpolação',
        krigingStep1: 'Remover linhas',
        krigingStep2: 'Selecionar datas',
        krigingStep1Desc: 'Clique nas waterlines no mapa para marcá-las para remoção. Clique novamente para desmarcar.',
        krigingStep2Desc: 'Selecione as datas que serão usadas na interpolação. Datas desmarcadas serão ignoradas.',
        linesMarked: 'linha(s) marcada(s) para remoção',
        noLinesMarked: 'Nenhuma linha marcada',
        confirmInterpolation: 'Confirmar Interpolação',
        exportKrigingTiff: 'Exportar Kriging (.tiff)',
        krigingEmptyMaskError:
          'Não foi possível gerar a interpolação Kriging para o índice espectral selecionado. Volte à etapa anterior e tente outro índice na definição da zona intermaré.',
        krigingMaskUnavailable:
          'Máscara da zona intermaré não disponível. Certifique-se de que a análise foi executada na etapa anterior.',
        krigingNoWaterlines: 'Nenhuma waterline disponível. Processe as waterlines primeiro.',
        waterlineProgress: '{{completed}} de {{total}} imagens processadas…',
        krigingAoiNotFound: 'Área de interesse não encontrada.',
        krigingNoTideValues: 'Nenhum valor de maré encontrado nas waterlines.',
        krigingVisualizationError:
          'Erro ao gerar visualização. A imagem pode ser muito grande. Tente aumentar o intervalo de amostragem.',
        krigingGenericError: 'Erro ao executar interpolação. Verifique o console para detalhes.',
        krigingExportMissingData: 'Gere a interpolação Kriging antes de exportar.',
        krigingGeotiffGenerationError: 'Erro ao gerar arquivo GeoTIFF. Verifique o console.',
        krigingGeotiffExportError: 'Erro ao exportar arquivo GeoTIFF.',
        generatingTiff: 'Gerando GeoTIFF...',
        viewTideChart: 'Ver gráfico de maré',
        tideChart: {
          dialogTitle: 'Gráfico do nível da maré',
          seriesLabel: 'Série da maré (Mín = {{min}}, Máx = {{max}})',
          acquisitionLabel: 'Imagens de satélite ({{count}})',
          xAxisLabel: 'data',
          yAxisLabel: 'nível da maré [m]',
          exportButton: 'Exportar imagem',
          showFullTimeline: 'Ver linha do tempo completa',
          showLimitedRange: 'Ver {{days}} dias antes/depois',
          noData: 'Nenhum dado de maré disponível.',
        },

        1: {
          title: 'Seleção do satélite',
          description: 'Escolha uma das opções para definir o dado de maré.',
          dateIntervalComments:
            '3 meses é o período ideal para análises da região entremarés. Períodos mais curtos podem gerar poucas imagens para análise. Períodos mais longos podem mascarar mudanças na morfologia, o que pode influenciar os resultados da topografia na zona entremarés.',
          card: {
            opticalResolution: 'Resolução ótica',
            opticalResolutionUnit: 'metros',
            activityPeriod: 'Período de atividade',
            provider: 'Fornecedor',
            revisitTime: 'Ciclo de captura',
            revisitTimeUnit: 'dias',
            choose: 'Escolher',
          },
        },
        2: {
          title: 'Seleção de áreas e dados de maré',
          description: 'Selecione a área de interesse, o período e os dados de maré.',
          showDelimiters: ' delimitadores',
        },
        3: {
          title: 'Aquisição das imagens',
          description: 'Filtre as imagens para a coleção, levando em consideração diferentes níveis de maré',
          loading: 'Carregando...',
        },
        4: {
          title: 'Aceite da área encontrada',
          description: 'Analise a área identificada como zona intermarés.',
          loading: 'Carregando...',
          period: 'Período',
          adjust: 'Ajustar',
          histogramTitle: 'Histograma do Desvio Padrão da Banda {{index}}',
          histogramDescription:
            'Através do histograma da imagem em termos de desvio padrão, selecione o limiar que divide a zona de intermarés das feições de água. Valores mais altos tenderão a gerar uma área menor.',
        },
        5: {
          title: 'Visualização das linhas de água extraídas',
          description: 'Visualização das linhas de água extraídas',
          cardText:
            'Considerando que o manguezal cresce em áreas que podem estar até 10 metros acima do nível do mar, o cálculo de compressão utiliza filtros de elevação do solo, com este valor sendo adotado como referência padrão.',
          confirm: 'CONFIRMAR',
        },
        validationStep: {
          title: 'Validação da área intermares',
        },
        result: {
          steps: 'Etapas',
          chartsTitle: 'Gráfico de evolução',
          cancel: 'Cancelar',
        },
      },
      algorithm: {
        title: 'Seleção de Módulo',
        beta: 'Beta',
        mepbay: 'MepBay',
        mepbayDesc: 'Modelo para plantas de equilíbrio de praias em baías.',
        bathymetry: 'Batimetria',
        bathymetryDesc:
          'Estimativa de profundidade de águas pouco profundas numa região costeira selecionada, usando algoritmos de inversão ótica e machine learning.',
        shoreline: 'Análise de Linha de Costa',
        shorelineDesc:
          'Mapeamento automático e análise estatística da evolução da linha de costa em qualquer área de interesse costeira no mundo, usando este módulo.',
        csqueeze: 'Compressão Costeira',
        csqueezeDesc:
          'Mapeamento e análise de indicadores para obtenção do potencial de Compressão Costeira (Coastal Squeeze) em áreas de manguezais.',
        euscoast: 'EUSCoast',
        euscoastDesc:
          'Identificação e avaliação de áreas de intervenção humana e evolução urbana na zona costeira, com o potencial de expansão da mancha urbana ao longo do período analisado.',
        intermare: 'Intermaré',
        intermareDesc: 'Estimativa de profundidade na região entre marés, utilizando o método de linhas de água.',
        shore_r: 'Shoreline-R',
        shore_rDesc:
          'Projeção estática de Linha de Costa baseada em tendências detectadas na série temporal selecionada.',
        shore_s: 'Shoreline-S',
        shore_sDesc: 'Validação e cálculo de Erro de modelagens sedimentares de Linha de Costa.',
        disclaimerTitle: 'Aviso',
        disclaimerText:
          'Ao continuar, você reconhece que a interpretação e o uso dos resultados gerados pela ferramenta são de sua responsabilidade e exigem conhecimento técnico adequado. Os desenvolvedores não se responsabilizam por análises e decisões tomadas com base nos resultados. O uso comercial está sujeito às regras e restrições do Google Earth Engine (GEE) - veja mais em: ',
        disclaimerReject: 'Recusar',
        disclaimerAccept: 'Aceitar',
      },
      acquisition: {
        title: 'Aquisição de Imagens',
        prev: 'Voltar',
        next: 'Continuar',
        sessionImport: {
          button: 'Importar sessão de teste',
          wrongModule: 'Este arquivo não é uma sessão exportada deste módulo.',
          error: 'Não foi possível importar o arquivo. Verifique se é uma sessão válida.',
          notAuthenticated:
            'Você precisa estar autenticado no Google Earth Engine para importar esta sessão. Faça login e tente novamente.',
          loading: 'Importando sessão...',
        },
        sessionExport: {
          button: 'Exportar sessão de teste',
        },
        pdfReport: {
          tooltip:
            'Baixar um relatório em PDF com toda a análise: área, imagens, modelo, métricas e mapas num documento só',
        },
        geoJsonExport: {
          tooltip:
            'Baixar as camadas desta análise (área, linha de base, transectos, resultados) em GeoJSON, para abrir em um SIG como o QGIS',
          empty: 'Esta análise ainda não tem camadas vetoriais para exportar.',
        },
        periodAndImages: {
          title: 'Período e imagens',
          description:
            'Defina o período e o filtro de nuvens, busque as imagens e escolha quais utilizar. Você pode ajustar o período e buscar novamente quantas vezes quiser, sem sair desta etapa.',
        },
        1: {
          title: 'Escolha o satélite',
          description: 'Selecione um dos satélites disponíveis para a aquisição de imagens.',
          card: {
            opticalResolution: 'Resolução ótica',
            opticalResolutionUnit: 'metros',
            activityPeriod: 'Período de atividade',
            provider: 'Fornecedor',
            revisitTime: 'Ciclo de captura',
            revisitTimeUnit: 'dias',
            about: {
              'Sentinel-2': 'Alta resolução e frequência de visita, ideal para análise costeira.',
              Landsat: 'Série histórica longa, ideal para análises temporais.',
            },
            choose: 'Escolher',
          },
          notice: {
            title: 'Qual satélite escolher?',
            sentinel:
              'O Sentinel-2 mostra mais detalhe: cada pixel cobre 10 m e o satélite passa pelo mesmo ponto a cada 5 dias. É a melhor escolha quando o detalhe importa (praias estreitas, esporões, desembocaduras) ou quando a análise é dos últimos anos.',
            landsat:
              'O Landsat tem a série mais longa: cada pixel cobre 30 m e o satélite passa a cada 16 dias, mas as imagens começam em 1984. É a melhor escolha quando o histórico importa (tendências de décadas, o antes e o depois de uma obra costeira).',
            combined:
              'Os dois juntos: a análise usa as imagens dos dois satélites, o que aumenta bastante o número de datas disponíveis. É a melhor escolha quando nenhum dos dois sozinho tem imagens boas o suficiente, lembrando que o detalhe varia conforme a origem de cada imagem (10 m nas do Sentinel-2, 30 m nas do Landsat).',
            tip: 'Na dúvida: se você precisa de detalhe, use o Sentinel-2; se precisa de histórico, use o Landsat. Em regiões com muita nuvem, aumente o período de busca nos dois casos, porque boa parte das passagens não gera imagem aproveitável.',
          },
        },
        2: {
          title: 'Defina a área de interesse',
          description: 'Delimite a área de interesse utilizando o mapa abaixo.',
          showDelimiters: ' delimitadores',
          undo: 'Desfazer',
          close: 'Fechar',
          processFile: 'Processar arquivo',
          importLegend: 'Importe a área de interesse por meio de um arquivo KML:',
          importTitle: 'Importar KML',
          noKmlFileSelected: 'Nenhum arquivo selecionado',
          example: 'Exemplos podem ser baixados aqui',
          dataTrainning: 'Dados de treino',
          dataTrainningLegend: 'Importe o arquivo de treino',
          dataTrainningFileLabel: 'Informe a data do arquivo de treino:',
          dataTrainningDateHint:
            '*Utilize um arquivo com nome encerrando com _ddmmyyyy.csv para ter a data de treino preenchida automatiamente.',
          bathymetryDescription: 'Defina a área de interesse e o arquivo de treino para continuar.',
          labelBathymetryStep: 'Defina a área de interesse e dados de treino',
          helpCoordinateSystem:
            'Por padrão o CASSIE interpreta as coordenadas com o sistema EPSG:4326 (WGS84 - Coordenadas Geográficas).\nMas caso o seu arquivo de treino esteja baseado em outro sistema de coordenadas EPSG,\nvocê pode digitar o código do seu sistema, que o CASSIE irá fazer a devida interpretação dos dados.',
          helpCoordinateSystemTitle: 'Sistema de Coordenadas',
          dataTrainningDateHintTitle: 'Data do Treino',
          checkboxIntertidal: 'Possíveis áreas de intermaré',
          referencePossibleTideGauge: 'Fonte da Camada "Possíveis Áreas de Intermaré"',
          possibleTideGaugeButtonToltip:
            'Este botão habilita a camada de zona entremarés global (UQ_murray Intertidal v1.1), um mapeamento mundial das áreas intermareais gerado a partir de dados de sensoriamento remoto e modelagens.',
          references: 'Referências:',
          seeLayerReference: 'Ver referência da camada',
          intertidalArea: 'Desenhe a área de interesse no mapa ou importe um arquivo KML.',
          intertidalPeriod: 'Período',
          intertidalTideData: 'Dados de maré',
          intertidalTideImportKmz: 'Importar kml',
          intertidalDrawOnMap: 'Desenhar no mapa',
          intertidalDrawOnMapDetails: 'Utilize os botões de desenho do mapa para definir a área de interesse.',
          intertidalTideImportData: 'Importar dado',
          intertidalTideExtractData: 'Extrair dado do modelo',
          intertidalPeriodSelection: 'Define o período de interesse',
          intertidalPeriodStartDate: 'Selecione a data de início do período de análise',
          intertidalPeriodEndDate: 'Selecione a data de fim do período de análise',
          intertidalSelectStartAndEndDate: 'Selecione a data de início e fim do período de análise:',
          intertidalCloudFilter: 'Defina a cobertura máxima de núvens: ',
          intertidalConfirmPeriod: 'Confirmar período',
          intertidalSelectAreaTitle: 'Escolha uma da opções da definir a área',
          intertidalSelectTideTitle: 'Escolha uma da opções da definir o dado de maré',
          bathymetry: {
            waterMaskMethod: 'Escolha um método para definir a máscara de terra',
            waterMaskThreshold: 'Informe o valor do limiar (entre -1 e 1)',
            trainingDataReducer: 'Selecione o redutor para os dados de treinamento',
            bringingModel: 'Vou carregar um modelo treinado',
            bringingModelHelp:
              'Libera o avanço sem CSV de sondagem. Use quando a intenção é aplicar um modelo salvo a esta imagem, e não ajustar um novo. O modelo é carregado na etapa dos algoritmos.',
            validationSplit: 'Separar pontos para validação',
            validationSplitHelp:
              'Ajusta o modelo com {{train}}% dos pontos de treino e mede o erro nos {{validation}}% restantes, que não entram no ajuste. Desligado, o erro é medido nos mesmos pontos usados para ajustar.',
          },
          bathymetryAoiChooser: {
            inputFilesAndSettings: 'Arquivos de entrada e configurações',
            inputFilesAndSettingsDescription:
              'Importe o arquivo KML da área de interesse, envie o CSV de treinamento, revise o sistema de coordenadas e defina as opções de processamento.',

            aoiFileTitle: 'Arquivo da área de interesse (.kml)',
            importKml: 'Importar KML',
            noKmlFileSelected: 'Nenhum arquivo KML selecionado.',
            aoiLoadedOnMap: 'Área de interesse carregada no mapa.',
            drawOnMapOrImportKml: 'Desenhe no mapa ou importe um arquivo KML.',

            trainingDataTitle: 'Dados de treinamento (.csv)',
            importCsv: 'Importar CSV',
            noCsvFileSelected: 'Nenhum arquivo CSV selecionado.',
            fileLabel: 'Arquivo:',
            pointsLabel: 'Pontos:',
            trainingDateTitle: 'Data do treinamento',
            trainingDatePlaceholder: 'dd/mm/aaaa',
            coordinateSystemTitle: 'Sistema de coordenadas',
            coordinateSystemExample: 'Exemplo: EPSG:4326',
            coordinateSystemLookup: 'Encontre valores de sistema de coordenadas aqui:',
            trainingDataReducerFallback: 'Redutor dos dados de treinamento',
            trainingPlotError:
              'Não foi possível desenhar os pontos de treino no mapa. Confira o sistema de coordenadas informado e se você está autenticado no Earth Engine.',
            thresholdPlaceholder: '0.124',
            confirmTrainingData: 'Confirmar dados de treinamento',
            areaOfInterestExample: 'Área de interesse (.kml)',
            trainingDataFile4326: 'Arquivo de dados de treinamento (.csv) - EPSG:4326',
            trainingDataFile32722: 'Arquivo de dados de treinamento (.csv) - EPSG:32722',
            coeficientsTitle: 'Adicionar coeficientes (opcional): ',
            coeficientsDescription:
              'Com a adição dos coefientes, os dados de treinamento importados serão utilizados para preencher a coluna "or_depth" e para o cálculo de métricas da batimetria. Preencha todos os campos de coeficientes para que eles sejam aplicados.',
            helpTrainingFileTitle: 'Formato do arquivo de entrada:',
            helpTrainingFileFormat: 'Formato: Valores separados por vírgula (.csv)',
            helpTrainingFileColumns: 'Colunas: 3',
            helpTrainingFileOrder: 'Ordem: X, Y, Z',
            helpTrainingFileDecimal: 'Decimal: ponto (.)',
            pressEscToClose: 'Pressione [ESC] para fechar.',
            confirmTrainingDataValidation:
              'Selecione o arquivo de dados de treinamento, informe a data e o sistema de coordenadas antes de continuar.',
            geeSignupError:
              'Sua conta ainda não está autorizada a usar a API do GEE. Complete seu cadastro neste link: https://earthengine.google.com/signup/',

            timezoneTitle: 'Fuso horário',
            invalidTideFile: 'Verifique o formato e o conteúdo do arquivo e tente novamente.',
            noTideFileSelected: 'Nenhum arquivo de maré selecionado. Por favor, selecione um arquivo para continuar.',
            tideFileFormat:
              'O arquivo de maré deve ser um arquivo CSV com duas colunas: datetime (formato: YYYY-MM-DD HH:mm:ss) e tideData (valor numérico).',
            importTideCsv: 'Importar arquivo CSV de maré (.csv)',
            tideDataTitle: 'Dados de maré',
            timezoneHelper: 'Ex: -3 para Brasília (BRT), 0 para UTC',
            tideTitle: 'Correção de maré',
            tideDatetimeField: 'Campo de data e hora',
            tideLevelField: 'Campo de nível',
            tideDatetimeFormat: 'Formato de data e hora',
            tideMaxDiff: 'Diferença máxima (minutos)',
            tideCompositeReducer: 'Redutor composto',
            tideApplyCorrection: 'Aplicar correção de profundidade',
            tideHint:
              'A correção de maré é aplicada para ajustar as estimativas de profundidade com base nos dados de maré fornecidos.',
            tideCsvFile: 'Importar dados de maré (.csv)',
            timezoneOffset: 'Fuso horário (offset em horas)',
            tideDateColumn: 'Coluna da data',
            tideValueColumn: 'Coluna do nível de maré',
            tideWarningTitle: 'Correção de maré ativada',
            tideWarningText:
              'Você ativou a correção de maré, mas ainda não importou um arquivo CSV de maré. Para continuar você precisa importar o arquivo ou seguir sem a correção.',
            tideWarningContinueWithout: 'Continuar sem',
            tideWarningImport: 'Importar',
            or: 'ou',
          },
        },
        3: {
          title: 'Defina o período',
          description: 'Especifique a data de início e data de término do conjunto de imagens.',
          startDate: 'Data inicial',
          endDate: 'Data final',
          warning: 'A data final não pode ser anterior à data inicial',
          languageTag: 'português',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          durationDays: {
            singular: 'dia',
            plural: 'dias',
          },
          durationMonths: {
            singular: 'mês',
            plural: 'meses',
          },
          durationYears: {
            singular: 'ano',
            plural: 'anos',
          },
          imageQuantity: {
            singular: 'imagem',
            plural: 'imagens',
          },
          cloudPercentage: 'Nível de nuvens',
          labelBathymetryStep: 'Selecione o período',
          contentBathymetryStep: 'Favor selecione o período desejado para continuar',
          loadingCloudCoverage: 'Carregando cobertura de nuvens...',
          loadingAvailableDates: 'Carregando datas disponíveis...',
          searchImages: 'Buscar imagens',
          noImagesFound: 'Nenhuma imagem encontrada para o período selecionado.',
          noImagesMatchCloudFilter:
            'Imagens foram encontradas para o período selecionado, mas nenhuma atende ao filtro de nuvens atual. Tente aumentar o nível de nuvens.',
          bathymetry: {
            selectIntervalTitle: 'ou selecione um intervalo',
            selectIntervalDescription: 'Clique para gerar uma imagem composta a partir de um intervalo de datas',
            selectPeriodButton: 'Selecionar período',
            compositeError:
              'Não foi possível gerar a imagem composta. O processamento excedeu o limite de memória ou os parâmetros selecionados são muito pesados. Tente reduzir o intervalo de datas e gerar novamente.',
            genericError: 'Ocorreu um erro inesperado. Tente novamente.',
            compositeReducer: 'Escolha o redutor de composição',
            description: 'Especifique uma imagem para ser utilizada:',
            imageDate: 'Data da imagem',
            dataDate: 'Data dos dados in-situ',
            downloadImage: 'Download imagem',
            intervalSelection: 'Clique aqui para selecionar o intervalo para imagem de mediana.',
            medianImage: 'Imagem mediana',
            intervalDefinition: 'Definição do intervalo',
            geomedWarning:
              'GEOMED_EPS deve ser um valor positivo pequeno usado apenas para estabilidade numérica. Valores típicos seguros estão entre 1e-6 e 1e-3. Valores maiores (ex.: ~1e-3) aumentam a estabilidade, mas suavizam os dados, enquanto valores menores (ex.: ~1e-6 ou menos) preservam mais detalhe, mas podem introduzir ruído ou instabilidade.',
            geomedPerformance:
              'A Mediana Geométrica Geomed é o redutor mais pesado. Evite utilizá-lo em coleções com muitas imagens. Recomenda-se utilizar períodos de no máximo 3 meses.',
            generateImage: 'Gerar imagem',
            invalidGeomedEps: 'Informe um valor válido para GEOMED_EPS maior que 0.',
            noImagesForPeriod: 'Nenhuma imagem foi encontrada para o período e área selecionados.',
            filteredCollectionNoBands: 'A coleção filtrada retornou uma imagem sem bandas.',
            generatedCompositeNoBands: 'A imagem composta gerada não possui bandas.',
            compositeGenerateError:
              'Ocorreu um erro ao gerar a imagem composta. Ajuste os parâmetros e tente novamente.',
            compositeRetry: 'Tentar novamente',
            geomedEpsInvalidHelp: 'Informe um número positivo válido. Exemplos: 1e-3, 1e-4, 0.001',
            geomedEpsHelp: 'Usado como valor mínimo antes do log(): img.toFloat().max(GEOMED_EPS).log()',
            compositePrepareError: 'Ocorreu um erro ao preparar a imagem composta. Tente novamente.',
            errorTimeout: 'A operação excedeu o tempo limite. Tente reduzir o período selecionado.',
            errorQuota: 'Limite de requisições atingido. Aguarde alguns minutos e tente novamente.',
            errorPermission: 'Sem permissão para acessar este recurso no Google Earth Engine.',
            errorNotRegistered: 'Conta não registrada no Google Earth Engine.',
            errorMemory: 'A área ou período é grande demais para processar. Reduza a região ou o intervalo de datas.',
            errorRequestSize:
              'Os dados enviados ao Earth Engine passaram do limite de 48 MB por pedido. O tamanho vem dos arquivos carregados, não da área: reduza o número de pontos do CSV de treino ou de vértices do KML.',
            treeErrorMemory:
              'As configurações de amostragem e validação do modelo pesaram demais para o Earth Engine. Reduza as amostras por faixa, o número de folds, ou use o conjunto de preditores Razões.',
            geoJsonDepthFailed:
              'Não foi possível vetorizar a profundidade. O arquivo foi gerado com a área e os pontos de treino, sem as faixas.',
            errorNetwork: 'Erro de conexão com o servidor. Verifique sua internet e tente novamente.',
            gaussianKernelPreview: 'Pré-visualização do kernel gaussiano',
            gaussianKernelPreviewDescription: 'Preview visual do kernel com raio e sigma.',
            parameters: 'Parâmetros',
            radius: 'Raio',
            sigma: 'Sigma',
            step1Title: 'Seleção do período',
            imagesInPeriod: 'Imagens disponíveis no período',
            loadImagesButton: 'Carregar imagens',
            step2Title: 'Lista de imagens',
            step3Title: 'Gerar imagem composta',
            periodChanged: 'O período foi alterado. Carregue as imagens novamente para atualizar a lista.',
            refreshTable: 'Clique para atualizar a tabela.',
            loadingImages: 'Carregando imagens...',
            generatingImage: 'Gerando imagem...',
            images: 'imagens',
            imagesSelected: 'Imagens selecionadas: ',
            smoothingVeryLight: 'Suavização muito leve',
            smoothingModerate: 'Suavização moderada',
            smoothingStrong: 'Suavização forte',
            smoothingVeryStrong: 'Suavização muito forte',
            smoothRadius: 'Raio de suavização',
            smoothSigma: 'Sigma de suavização',
            kernelLabel: 'Tamanho do kernel',
          },
        },
        4: {
          title: 'Filtre as imagens',
          description: 'Aplique filtros para manter somente as imagens apropriadas.',
          table: {
            id: 'ID',
            cloud: 'Nuvens',
            viewMode: 'Modo de exibição',
            viewGrid: 'Ver em grade',
            viewList: 'Ver em lista',
            thumbnail: 'Miniatura',
            tide: 'Maré',
            selected: 'Selecionado',
            noData: 'Sem dados disponíveis',
          },
          imagesPerPage: 'Imagens por página',
          to: 'a',
          of: 'de',
          importDates: 'Importar datas (CSV)',
          importResult: '{{matched}} de {{total}} datas encontradas e selecionadas.',
          importEmpty: 'Nenhuma das datas do arquivo corresponde às imagens desta lista.',
          importInvalid: 'Nenhuma data válida foi encontrada no arquivo. Colunas esperadas: name, date.',
          importError: 'Não foi possível ler o arquivo.',
          labelBathymetryStep: 'Selecione as bandas, o algoritmo e a linha de corte',
          contentBathymetryStep: 'Selecione as bandas, o algoritmo e linha de corte a ser aplicada.',
          next: 'Concluir',
          attention: 'ATENÇÃO:',
          attentionMessage:
            'Dependendo do intervalo de datas e da área de interesse selecionados, a imagem de satélite pode aparecer incompleta devido à disponibilidade de cenas no Google Earth Engine. Avalie cuidadosamente se deseja selecionar apenas imagens completas ou aproveitar os trechos disponíveis para análises locais de linhas de costa, considerando essa limitação ao interpretar a evolução costeira.',
          reloadFullList: 'Recarregar todas as imagens encontradas antes da seleção',
          bathymetry: {
            modelSelection: 'Selecione um modelo de treinamento',
            algorithmSelection: 'Selecione um algoritmo',
            algorithmSelectionHint:
              'Clique no gráfico para selecionar o algoritmos. O algoritimo selecionado ficará com bordas vermelhas.',
            thresholdSelection: 'Linha de corte para extinção da luz (metros)',
            algorithmName1: 'Razão de bandas',
            bandsSelection: 'Seleção de bandas',
            band: 'Banda',
            updateCharts: 'Atualizar gráficos',
            modelStore: {
              load: 'Carregar modelo treinado',
              loadHelp:
                'Aplica um modelo salvo em outra análise em vez de treinar um novo. Útil para rodar as mesmas regras sobre imagens de outras datas.',
              loaded:
                'Usando o modelo {{model}} treinado em {{date}} com {{samples}} pontos. O ajuste será pulado nesta análise.',
              notJson: 'O arquivo não é um JSON válido.',
              notAModel: 'Este arquivo não é um modelo de batimetria do CASSIE.',
              version: 'Este modelo foi salvo por uma versão diferente do CASSIE e não pode ser lido.',
              unknownModel: 'O modelo salvo não é Random Forest, Gradient Boost nem Ensemble.',
              noPredictors: 'O modelo salvo não diz com quais preditores foi treinado.',
              noTrees: 'O modelo salvo não contém as árvores treinadas.',
              mismatch:
                'O modelo foi treinado em imagens {{expected}}, mas agora está selecionado {{actual}}. As bandas têm os mesmos nomes e o modelo responderia mesmo assim, com dados errados.',
              missingPredictors:
                'O modelo precisa de preditores que estas configurações não produzem: {{names}}. Troque o conjunto de preditores para o que ele foi treinado.',
            },
            treeCalibration: 'Calibração do modelo',
            treeCalibrationHelp:
              'Modelos de árvore não geram coeficientes: o que se ajusta são os hiperparâmetros abaixo. Os valores padrão são os do script de referência; altere um por vez e compare o RMSE por faixa de profundidade.',
            treeRfTrees: 'RF: nº de árvores',
            treeRfVarsPerSplit: 'RF: vars por split',
            treeRfMinLeaf: 'RF: mín. por folha',
            treeRfBagFraction: 'RF: fração bag',
            treeGbtTrees: 'GBT: nº de árvores',
            treeGbtShrinkage: 'GBT: shrinkage',
            treeGbtSamplingRate: 'GBT: amostragem',
            treeGbtMaxNodes: 'GBT: nós máx.',
            treeGbtLoss: 'GBT: perda',
            treeEnsembleWeight: 'Peso do RF',
            treeVarsMode: { P3: 'n/3 (regressão)', SQRT: 'raiz de n' },
            treePredictors: 'Preditores',
            treePredictorsHelp:
              'Completo é a configuração de referência: todas as bandas ópticas, SPM02, as razões pSDB e as estatísticas de vizinhança 3×3. Os conjuntos menores servem para isolar de onde vem o erro. Logaritmos ficam de fora de propósito: a árvore parte por limiar, então log(B) é a mesma divisão que B.',
            treeValidation: 'Validação',
            treeValidationHelp:
              'Folds de terreno, não de pontos: dois pixels a trinta metros um do outro veem quase a mesma água sobre quase o mesmo fundo, então uma divisão aleatória mede o modelo num vizinho daquilo em que ele foi ajustado. Bloco maior é mais pessimista e mais honesto.',
            treeCvScheme: 'Validação cruzada',
            treeCvFolds: 'CV: folds',
            treeCvBlock: 'CV: bloco (m)',
            treeStratifyBin: 'Faixa estratos (m)',
            treeSamplesPerBin: 'Amostras por faixa',
            treeEnsembleWeighting: 'Peso do ensemble',
            treeCvSchemes: { BLOCK: 'Blocos espaciais', RANDOM: 'Aleatória', NONE: 'Desligada' },
            treeWeightings: { OPTIMAL: 'Ótimo (out-of-fold)', INV_MSE: 'Pelo erro inverso', EQUAL: 'Metades iguais' },
            treePredictorsFull: 'Completo',
            treePredictorsBands: 'Bandas',
            treePredictorsRatios: 'Bandas + razões',
            errorTitle: 'Error',
          },
        },
        5: {
          bathymetry: {
            bathymetry: 'Batimetria',
            metricsReport: 'Relatório de Métricas',
            loadStatistics: 'Clique aqui para carregar as estatísticas',
            returnToBegin: 'Voltar à seleção de módulos',
            meters: 'metros',
            minDepth: 'Profundidade Mínima Prevista',
            maxDepth: 'Profundidade Máxima Prevista',
            processing:
              'Processando...<br />Pode levar alguns segundos dependendo do tamanho dos dados de treinamento.',
            downloadStatistics: 'Baixar estatísticas',
            legendTitle: 'Batimetria Derivada por Satélite - Profundidade (m)',
            shorelineAnalysis: 'Análise de Linha de Costa',
            applyMosaic: 'Aplicar mosaico à imagem',
            pdfReport: {
              title: 'Relatório de Batimetria',
              subtitle: 'CASSIE · modelo {{model}} · gerado em {{date}}',
              footer: 'CASSIE · Coastal Analysis via Satellite Imagery Engine',
              missingImage: 'A imagem "{{caption}}" não pôde ser incluída: o navegador não liberou o arquivo.',
              failed: 'Não foi possível gerar o relatório em PDF.',
              areaHeading: 'Área de estudo',
              areaFile: 'Arquivo da área',
              areaExtent: 'Extensão (lon, lat)',
              crs: 'Sistema de coordenadas',
              soundingsFile: 'Arquivo de sondagens',
              soundings: 'Sondagens',
              surveyedRange: 'Profundidade levantada',
              surveyDate: 'Data do levantamento',
              imageryHeading: 'Imagens',
              mission: 'Satélite',
              resolution: 'Resolução óptica',
              processing: 'Processamento',
              period: 'Período',
              waterMask: 'Máscara d\'água',
              waterThreshold: 'Limiar da máscara',
              imageCount: 'Imagens no composite',
              imageList: 'Datas usadas',
              modelHeading: 'Modelo',
              model: 'Modelo',
              bands: 'Bandas',
              extinctionDepth: 'Profundidade de extinção',
              trainingReducer: 'Redutor das sondagens',
              validationSplit: 'Validação 70/30',
              validationSplitOn: 'ligada — as métricas vêm dos 30% reservados',
              validationSplitOff: 'desligada — as métricas vêm dos mesmos pontos do ajuste',
              predictorSet: 'Conjunto de preditores',
              seed: 'Semente',
              presetNote:
                'Os coeficientes foram informados manualmente, não ajustados nesta análise. As métricas medem o desempenho deles sobre estas imagens.',
              metricsHeading: 'Métricas',
              metricsNote:
                'As métricas comparam a profundidade prevista com a sondada, pixel a pixel, dentro da área analisada.',
              binsHeading: 'Erro por faixa de profundidade',
              binsNote:
                'Faixas de 2 m sobre a profundidade sondada. Uma faixa com poucos pontos diz mais sobre o levantamento do que sobre o modelo.',
              depthCoarsened:
                'A área tem {{requested}} pixels com profundidade, acima do limite do arquivo. Os pontos foram amostrados a cada {{scale}} m em vez da resolução do satélite, cobrindo a área inteira com {{written}} pontos em vez de recortá-la.',
              overallRmse: 'RMSE médio geral',
              warningsHeading: 'Atenção',
              warningsNote:
                'Estes pontos não invalidam o resultado, mas mudam o quanto se pode confiar nele. Confira antes de citar os números.',
              staleWarning:
                'A batimetria de treinamento é de {{survey}} e a imagem é de {{image}}, {{years}} anos depois. O modelo supõe que o fundo medido pela sondagem é o fundo que a imagem vê; num sistema costeiro móvel esse intervalo pode estar sendo medido como erro do modelo.',
              thinWarning:
                'Faixas com menos de {{limit}} pontos: {{bands}}. O erro nelas diz mais sobre o tamanho da amostra do que sobre o modelo.',
              binChart: {
                xLabel: 'Profundidade (m)',
                yLabel: 'RMSE (m)',
                caption:
                  'RMSE por faixa de 2 m, no ponto médio de cada faixa. Onde a curva é baixa e plana é onde o modelo é confiável.',
              },
              binBand: 'Faixa',
              binCount: 'n',
              binRmse: 'RMSE (m)',
              binMae: 'MAE (m)',
              binBias: 'Viés (m)',
              mapsHeading: 'Mapas',
              depthCaption: 'Profundidade estimada pelo modelo',
              imageCaption: 'Imagem de trabalho em cor verdadeira',
            },
            treeCvDegenerate:
              'Os pontos de treino cabem todos num único bloco de {{block}} m, então não há como separar folds no espaço. O modelo foi ajustado e o mapa vale, mas sem erro de validação cruzada. Reduza o tamanho do bloco para um valor menor que a área levantada.',
            modelStore: {
              save: 'Salvar modelo treinado',
              saving: 'Salvando o modelo…',
              nothingToSave: 'Nenhum modelo treinado nesta análise. Rode um dos modelos de árvore primeiro.',
            },
            treeNoSamples:
              'Nenhum ponto de treino sobreviveu à seleção de preditores. Um ponto só vale quando todos os preditores têm valor nele, e o SPM02 e as estatísticas de vizinhança ficam sem valor em parte da cena. Tente o conjunto Razões, ou amplie a linha de corte.',
            treeNeedsTraining:
              'Os modelos de árvore aprendem a profundidade a partir dos pontos de treino, então não rodam sem eles. Volte e importe um CSV de treinamento, ou escolha um dos modelos analíticos.',
            presetMismatch:
              'Os coeficientes informados foram ajustados em imagens {{expected}}, mas agora está selecionado {{actual}}. Volte e selecione as mesmas imagens, ou informe coeficientes ajustados para estas.',
            viewTideChart: 'Gráfico de maré',
            exportSessionState: 'Exportar sessão para teste',
            tideChart: {
              title: 'Gráfico do nível da maré',
              dialogTitle: 'Gráfico do nível da maré',
              seriesLabel: 'Série da maré (Mín = {{min}}, Máx = {{max}})',
              acquisitionLabel: 'Aquisição da imagem (Intervalo médio: {{days}} dias)',
              chartTitle: 'Níveis de maré no momento da aquisição da imagem',
              yAxisLabel: 'nível da maré [m]',
            },
            bathymetryProcessing: {
              generateCsv: 'Gerar CSV - Batimetria',
              generateMetricsCsv: 'Gerar CSV das métricas',
              csvExportSplitWarning:
                'A área selecionada tem ~{{pixels}} pixels, acima do limite de {{limit}} por exportação. Ela será dividida automaticamente em {{parts}} partes e processada em sequência.',
              csvExportProgress: 'Processando área {{current}} de {{total}}...',
              downloadingImages: 'Baixando imagens...',
              downloadGeotiff: 'Download GeoTIFF',
              generateChart: 'Gerar gráfico',
              metricsReport: 'Relatório de Métricas',
              errorByDepth: 'RMSE por faixa de profundidade',
              disableImage: 'Desativar imagem RGB',
              hideDepthImage: 'Ocultar imagem de profundidade',
              showDepthImage: 'Mostrar imagem de profundidade',
              enableImage: 'Ativar imagem RGB',
              metrics: {
                BDS_MODEL: 'Modelo',
                MISSION: 'Missão',
                IMAGE_SOURCE: 'Fonte da Imagem',
                RUN_MODE: 'Modo de Execução',
                SCALE_M: 'Escala (m)',
                CRS: 'CRS',
                targetDate: 'Data Alvo',
                n: 'Amostras',
                rmse: 'RMSE',
                mae: 'MAE',
                bias: 'Viés',
                r2: 'R²',
                SI: 'Índice de Dispersão',
                nRMSE: 'nRMSE',
                skill: 'Skill Score',
                tideLevel_m: 'Nível da Maré (m)',
                dateGauge: 'Data do Marégrafo',
                dateImage: 'Data da Imagem',
                TRAININGDATA_REDUCER: 'Redutor de Treino',
                VALIDATION_SPLIT: 'Divisão treino/validação (%)',
                TREE_ENSEMBLES: 'Algoritmos',
                TREE_PREDICTOR_SET: 'Conjunto de preditores',
                TREE_PREDICTOR_COUNT: 'Preditores (total)',
                MODEL_SOURCE: 'Origem do modelo',
                MODEL_TRAINED_ON: 'Treinado em',
                MODEL_TRAINED_SAMPLES: 'Pontos do treino original',
                TREE_N_SAMPLES: 'Pontos de treino',
                TREE_PREDICTORS: 'Preditores',
                TREE_RF_N_TREES: 'RF: árvores',
                TREE_RF_VARS_PER_SPLIT: 'RF: vars por split',
                TREE_RF_MIN_LEAF: 'RF: mín. por folha',
                TREE_RF_BAG_FRACTION: 'RF: fração bag',
                TREE_GBT_N_TREES: 'GBT: árvores',
                TREE_GBT_SHRINKAGE: 'GBT: shrinkage',
                TREE_GBT_SAMPLING_RATE: 'GBT: amostragem',
                TREE_GBT_MAX_NODES: 'GBT: nós máx.',
                TREE_GBT_LOSS: 'GBT: perda',
                TREE_ENSEMBLE_W_RF: 'Peso do RF no ensemble',
                CV_SCHEME: 'Validação cruzada',
                CV_FOLDS: 'CV: folds',
                CV_BLOCK_M: 'CV: bloco (m)',
                CV_N: 'CV: amostras',
                CV_FOLDS_ASKED: 'CV: folds pedidos',
                CV_DEGENERATE: 'CV: bloco sem divisão',
                CV_RMSE: 'CV: RMSE',
                CV_MAE: 'CV: MAE',
                CV_BIAS: 'CV: viés',
                CV_R2: 'CV: R²',
              },
            },
          },
        },
      },
      map: {
        roi: 'Área de interesse',
        baseline: 'Linha de Base',
        shorelines: 'Linhas de Costa',
        showAll: 'Mostrar todos',
        transects: {
          title: 'Transectos',
          legend: 'Legenda de cores',
          stable: 'Estável',
          accreted: 'Acrescida',
          eroded: 'Erodida',
          criticallyEroded: 'Criticamente Erodida',
          biasPositive: 'Viés positivo',
          biasNegative: 'Viés negativo',
          biasNoData: 'Sem dado',
        },
        coastlineShoreR: {
          title: 'Transectos',
          stable: 'Estável',
          accreted: 'Progradação',
          eroded: 'Retração',
          criticallyEroded: 'Retração extrema',
        },
        item: {
          s: 'item',
          p: 'itens',
        },
        cancel: 'Cancelar',
        edit: 'Editar',
        finishEdit: 'Confirmar',
        editTooFewPoints: 'A área precisa de pelo menos 3 pontos.',
        editSelfIntersection: 'A área não pode se cruzar. Ajuste os pontos antes de continuar.',
        editOutsideAOI: 'A linha de base deve permanecer dentro da área de interesse.',
      },
      imageChooser: {
        title: 'Mapa de fundo',
        resultQuantity: 'imagens disponíveis',
        helpTooltip: 'Veja todos os mapas selecionados na área de seleção de imagens por data',
        helpContent:
          'Esta seção exibe as imagens de satélite que foram previamente selecionadas durante a etapa de escolha de datas.',
        image: 'Imagem',
        load: 'Carregar',
        exportDates: 'Exportar datas (CSV)',
        actions: {
          title: 'Ações',
          analyzeShoreline: {
            title: 'Analisar linha de costa',
            imageSelection: {
              title: 'Selecionar imagens',
              cancel: 'Cancelar',
              confirm: 'Confirmar',
            },
            baselineDraw: 'Desenhar linha base',
          },
        },
      },
      shorelineParameters: {
        title: 'Parâmetros de análise',
        description:
          'Defina os parâmetros de espaçamento e extensão dos transectos, em metros, e o coeficiente de limiarização (valores mais altos são mais rígidos quanto ao que é considerado um corpo de água).',
        spacing: 'Espaçamento (m)',
        extension: 'Extensão (m)',
        threshold: 'Limiar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      shoreR: {
        moduleName: 'Shoreline-R',
        analysis: {
          title: 'Shoreline-R',
          execute: 'Confirmar e Iniciar Análise',
          step: '3. Executar Análise',
        },
        timeSeriesHint: {
          title: 'ATENÇÃO:',
          message:
            'Considere que projeções baseadas em linhas de costa históricas tendem a apresentar melhores resultados com séries temporais mais longas.',
        },
        periodHint: {
          title: 'ATENÇÃO:',
          message:
            'Especifique a data de início e data de término do conjunto de imagens. Considere que a média das imagens do último ano da série temporal pode ser utilizada como referência para a projeção.',
        },
        baseline: {
          title: '1. Linha Base',
          draw: 'Desenhar linha base',
          confirm: 'Confirmar linha base',
        },
        transects: {
          title: '2. Transectos',
          confirm: 'Confirmar transectos',
        },
        projection: {
          legendLabel: 'Projeção',
          title: '4. Configurar Projeção',
          horizonLabel: 'Horizonte temporal (anos)',
          customYearPlaceholder: 'Outro',
          addCustomYear: 'Adicionar',
          maxHorizonsWarning: 'Máximo de {{max}} períodos atingido',
          methodLabel: 'Método de extrapolação',
          methods: {
            smoothed_linear_regression: 'Regressão Linear',
            smoothed_end_point_rate: 'Taxa de Ponto Final (EPR)',
          },
          referenceShorelineLabel: 'Linha de costa de referência',
          referenceShorelineModes: {
            latest: 'Mais recente (padrão)',
            byDate: 'Escolher por data',
            yearlyMean: 'Média do último ano',
          },
          referenceShorelineDateLabel: 'Data',
          confirm: 'Confirmar configuração',
          yearUnit: 'anos',
        },
        bruun: {
          openButton: 'Ajuste de Nível do Mar Futuro',
          title: 'Ajuste por Nível do Mar Futuro (Regra de Bruun)',
          horizonLabel: 'Horizonte de projeção',
          slraLabel: 'SLRa (mm/ano)',
          lLabel: 'L - Dist. até fechamento (m)',
          hStarLabel: 'h* - Prof. de fechamento (m)',
          dcLabel: 'DC - Altura da praia/duna (m)',
          confirm: 'Aplicar Ajuste',
          undo: 'Desfazer Ajuste',
          legendLabel: 'Bruun',
          formulaLabel: 'Fórmula',
          helpTooltip: 'Sobre a Regra de Bruun',
          helpContent:
            'A Regra de Bruun estima o recuo horizontal da linha de costa causado pela elevação do nível do mar. O cálculo usa a taxa de SLR, o horizonte temporal e as dimensões do perfil praial (distância ao fechamento, profundidade de fechamento e altura da duna/praia).',
        },
        redoLastStep: 'Refazer Projeção',
        redoAnalysis: 'Refazer Análise',
        outlierDialog: {
          title: 'Outlier',
          description:
            'As seguintes possuem a distâncias fora de mediana ± 3σ em pelo menos 1/5 dos transectos. Marque as datas que deseja remover e a análise será refeita sem elas.',
          confirm: 'Continuar',
        },
        exports: {
          openButton: 'Exportar',
          title: 'Exportar Análise ShoreR',
          close: 'Fechar',
          empty: 'Selecione ao menos um item.',
          formatLabel: 'Formato',
          export: 'Exportar',
          nonGeoref: {
            title: 'Não-georreferenciados',
            coastlineAnalysis: 'Análise de linha de costa',
            rates: 'Taxas calculadas por transecto',
            extrapolations: 'Extrapolações calculadas por transecto',
          },
          georef: {
            title: 'Georreferenciados',
            shorelines: 'Linhas de costa',
            reference: 'Linha de referência',
            baseline: 'Linha de base',
            future: 'Linhas futuras',
            transects: 'Transectos',
          },
        },
      },
      shorelineAnalysis: {
        title: 'Análise da Linha de Costa',
        navSubtitle: 'Análise e monitoramento costeiro',
        moduleName: 'Linha de Costa',
        navMapTab: 'Mapa',
        layersPanelTitle: 'Camadas',
        backgroundMapTitle: 'Mapa de fundo',
        mapTypeMap: 'Mapa',
        mapTypeSatellite: 'Satélite',
        mapTypeLabels: 'Marcadores',
        mapTypeTerrain: 'Relevo',
        mapTypeTerrainUnavailable: 'O Google não oferece camada de relevo sobre imagem de satélite',
        mapTypeDark: 'Escuro',
        toggleTheme: 'Alternar modo claro/escuro',
        toggleThemeUnavailable: 'Indisponível nesta página',
        baselineAOIDrawAlert: 'A linha de base deve estar dentro da área de interesse.',
        transectsSettings: {
          defineTransects: 'Defina a quantidade de transectos da linha de base:',
          setStepLabel: 'Distância entre transectos em metros',
          setExtentLabel: 'Extensão dos transectos em metros',
          importTransectsStepsExtent: 'Importar transectos para obter distância e extensão (.kml)',
          or: 'ou:',
          importBaseline: 'Importar Linha de Base (.kml)',
          setThresholdLabel: 'Determine o Coeficiente de Limiarização',
          confirm: 'Confirmar e Começar a Análise',
          alert: {
            importTransectQuantity: 'O arquivo deve conter no mínimo 2 transectos',
          },
        },
        transectsReport: {
          title: 'Relatório de Transectos',
          headers: {
            id: 'ID',
            initialLatitude: 'Latitude inicial',
            initialLongitude: 'Longitude inicial',
            finalLatitude: 'Latitude final',
            finalLongitude: 'Longitude final',
            initialDate: 'Data inicial',
            finalDate: 'Data final',
            intercept: 'Intercepto',
            slope: 'Inclinação',
            rsquared: 'r²',
            lrr: 'LRR',
            sce: 'SCE',
            nsm: 'NSM',
            epr: 'EPR',
            label: 'Classe',
          },
        },
        process: {
          extraction: 'Extraindo linhas de costa',
          estimate: 'Estimado',
        },
        exports: {
          title: 'Exportar Dados de Transectos',
          csv: 'Exportar CSV',
          json: 'Exportar JSON',
          shp: 'Exportar Shapefile',
          images: 'Exportar Imagens',
          kml: 'Exportar KML',
          sessionState: 'Exportar sessão para teste',
        },
        restartAnalysis: 'Reiniciar Análise',
        close: 'Fechar',
        toggleLayers: {
          on: 'Ligar camadas',
          off: 'Desligar camadas',
        },
        errors: {
          invalidTransectError: 'Não foi possível calcular as linhas de costa.',
        },
      },
      transectEvolution: {
        chartLanguage: 'Português',
        title: 'Evolução do Transecto',
        TransectEvolutionDialog:
          'Informações sobre a análise da evolução da linha de costa ao longo do tempo, incluindo regressão linear, taxas de variação diária, mensal e anual, coeficiente de determinação (R²), desvio padrão, incertezas e detecção de outliers.',
        TransectEvolutionInfoDialog:
          'Para iniciar a análise, é necessário selecionar as imagens de satélite desejadas, desenhar a linha de base ao longo da costa e configurar os transectos. A configuração dos transectos inclui a definição da distância entre os transectos, o tamanho (comprimento) de cada transecto e o valor de limiar (threshold) para filtrar os dados considerados na análise. Esses parâmetros influenciam diretamente a precisão e a sensibilidade dos resultados obtidos.',
        MeanTransectDialog:
          'Este gráfico exibe a posição média da linha costeira ao longo do tempo com base nos dados de transecto disponíveis; para cada data, ele reúne as distâncias da linha costeira de todos os transectos com dados, calcula a média dessas distâncias e produz uma série temporal que ajuda a visualizar as tendências gerais de avanço ou recuo da linha costeira sem se concentrar nas variações individuais dos transectos.',
        statistics: 'Estatísticas',
        slope: 'Inclinação da regressão (slope)',
        intercept: 'Intercepto da regressão',
        lrr: 'Taxa de alteração (LRR)',
        r: 'Coeficiente de correlação (r)',
        sce: 'SCE - Faixa de Mudança da Linha de Costa',
        nsm: 'NSM - Deslocamento Líquido na costa',
        epr: 'EPR - Taxa de variação entre pontos extremos',
        eprUnc: 'EPRunc - Incerteza da taxa entre pontos extremos',
        lse: 'LSE - Erro padrão da regressão',
        lci: 'LCI - Intervalo de confiança da regressão',
        meanTransect: 'Média dos Transectos',
        averageBeachProfile: 'Perfil Médio da Praia',
        label: 'Classificação',
        units: {
          meters: 'm',
          mByYr: 'm/ano',
          mByMonth: 'm/mês',
          metersPerDay: 'm/dia',
        },
        labels: {
          x: 'Ano',
          y: 'Distância da Linha de Base (m)',
          trend: 'Tendência',
        },
        outliers: 'Remover Outliers: ',
        deviation: 'Desvio Padrão: ',
        downloadchart: 'Download do gráfico',
        transectList: 'Filtro de Transectos: ',
        exportChart: 'Exportar Gráfico',
        chartTitle: 'Evolução do Transecto',
        noData: 'Sem dados',
        averagePosition: 'Posição média da linha costeira ao longo do tempo',
        hovmollerPlot: 'Gráfico de Hovmöller',
      },
      hovmoller: {
        hovmollerInfoDialog:
          'O gráfico Hovmöller representa a variação da posição média da linha de costa ao longo do tempo para cada transecto, permitindo identificar padrões de avanço (acréscimo) ou recuo (erosão) em diferentes períodos.',
        hovmollerPlot: 'Gráfico Hovmöller',
        popupTitle: 'Gráfico Hovmöller',
        xAxisLabel: 'Data',
        yAxisLabel: 'Transecto',
        colorbarTitle: 'Distância em relação à posição média (m)',
        colorbarLabels: {
          low: 'Recuo / Erosão',
          mid: 'Posição Média',
          high: 'Avanço / Acréscimos',
        },
        close: 'Fechar',
      },
      imageryOverlay: {
        base: 'Base',
        hint: 'Nova camada',
        loading: 'Carregando',
        noLayers: 'Nenhuma camada nesta imagem ainda.',
        plotBathymetry: 'Clique aqui para plotar a imagem de batimetria.',
        plotMedian: 'Clique aqui para plotar a imagem de mediana.',
        bathymetryLoad: "Clique em 'Criar' para exibir a camada com a imagem da batimetria.",
        medianLoad: "Clique em 'Criar' para exibir a camada com a imagem da mediana.",
        MedianLoad: "Clique em 'Criar' para exibir a camada com a imagem da mediana.",
        add: {
          title: 'Nova camada',
          name: 'Nome da camada',
          expression: 'Expressão',
          bands: {
            title: 'Bandas disponíveis',
            red: 'RED: Banda vermelha',
            green: 'GREEN: Banda verde',
            blue: 'BLUE: Banda azul',
            nir: 'NIR: Banda infravermelho próximo',
            swir: 'SWIR: Banda infravermelho de ondas curtas',
          },
          suggested: 'Expressões',
          create: 'Criar',
        },
      },
      bathymetry: {
        moduleName: 'Batimetria',
        exportCSVBathymetry: 'Gerar CSV - Batimetria',
        exportCSVMetrics: 'Gerar CSV - Métricas',
      },
      csqueeze: {
        moduleName: 'Compressão Costeira',
        title: 'Compressão Costeira',
        prev: 'Voltar',
        next: 'Continuar',
        year: 'Ano',
        years: 'anos',
        landcovers: {
          mangrove: 'Manguezal',
          vegetation: 'Vegetação',
          water: "Corpo d'agua",
          human: 'Intervenção humana',
          beach: 'Praia, Duna e Areal',
          intertidal: 'Intermaré',
        },
        1: {
          title: 'Escolha o satélite',
          description: 'Selecione um dos satélites disponíveis para a aquisição de imagens.',
          card: {
            opticalResolution: 'Resolução ótica',
            opticalResolutionUnit: 'metros',
            activityPeriod: 'Período de atividade',
            provider: 'Fornecedor',
            revisitTime: 'Ciclo de captura',
            revisitTimeUnit: 'dias',
            choose: 'Escolher',
          },
        },
        2: {
          title: 'Defina a área de interesse',
          description: 'Delimite a área de interesse utilizando o mapa abaixo.',
          showDelimiters: ' delimitadores',
          undo: 'Desfazer',
          processFile: 'Processar arquivo',
          importLegend: 'Importe a área de interesse por meio de um arquivo KML:',
          importTitle: 'Importar KML',
          aoiFileTitle: 'Área de interesse',
          fileLabel: 'Arquivo:',
          noKmlFileSelected: 'Nenhum arquivo KML selecionado.',
          aoiLoadedOnMap: 'Área de interesse carregada no mapa.',
          drawOnMapOrImportKml: 'Desenhe no mapa ou importe um arquivo KML.',
          example: 'Exemplos podem ser baixados aqui',
          dataTrainning: 'Dados de treino',
          dataTrainningLegend: 'Importe o arquivo de treino',
          dataTrainningFileLabel: 'Informe a data do arquivo de treino:',
          dataTrainningDateHint:
            '*Utilize um arquivo com nome encerrando com _ddmmyyyy.csv para ter a data de treino preenchida automatiamente.',
          bathymetryDescription: 'Defina a área de interesse e o arquivo de treino para continuar.',
          labelBathymetryStep: 'Defina a área de interesse e dados de treino',
          helpCoordinateSystem:
            'Por padrão o CASSIE interpreta as coordenadas com o sistema EPSG:4326 (WGS84 - Coordenadas Geográficas).\nMas caso o seu arquivo de treino esteja baseado em outro sistema de coordenadas EPSG,\nvocê pode digitar o código do seu sistema, que o CASSIE irá fazer a devida interpretação dos dados.',
          performanceMessage: 'A área marcada possui {number} km² e terá um desempenho {level} durante os cálculos.',
          slow: 'lento',
          moderate: 'moderado',
          fast: 'rápido',
          viewMangrove: 'Possíveis áreas de manguezal',
          geeError: {
            title: 'Aviso de Erro!',
            content:
              'Parece que a sua conta ainda não está autorizada a usar as ferramentas do Google Earth Engine. Você precisa completar seu registro através deste link: ',
            close: 'Fechar',
          },
          errorTitle: 'Mensagem de erro',
          errorMessageSelectFile: 'Por favor, selecione um arquivo primeiro.',
          errorMessageDrawingOutline: 'Por favor, selecione um arquivo primeiro.',
          errorMessageNoValidCoord: 'Nenhuma coordenada válida foi encontrada no arquivo KML.',
          errorMessageUnableInterpretKml: 'Não foi possível interpretar o arquivo KML.',
          infoTitle: 'Mensagem informativa',
          infoMessageSuccess: 'Arquivo KML processado com sucesso.',
          close: 'Fechar',
        },
        3: {
          title: 'Seleção de imagens - 1',
          description:
            'Visualize as imagens e adicione-as a lista.\n Ao selecionar mais de uma imagem por período, será gerada uma imagem mediana final.\n Imagens com nuvens terão aplicação de filtro de remoção',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          durationDays: {
            singular: 'dia',
            plural: 'dias',
          },
          durationMonths: {
            singular: 'mês',
            plural: 'meses',
          },
          durationYears: {
            singular: 'ano',
            plural: 'anos',
          },
          imageQuantity: {
            singular: 'imagem',
            plural: 'imagens',
          },
          cloudPercentage: 'Nível de nuvens',
        },
        4: {
          title: 'Seleção de imagens - 2',
          description:
            'Visualize as imagens e adicione-as a lista.\n Ao selecionar mais de uma imagem por período, será gerada uma imagem mediana final.\n Imagens com nuvens terão aplicação de filtro de remoção',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          with: 'com',
          tabText: 'Selecione as datas disponíveis na barra clicando nos pontos rosas abaixo:',
          emptyImages: 'Nenhuma imagem encontrada com essa porcentagem de nuvens.',
          viewImage: 'Visualizar imagem',
          listText: '*Selecione ao menos 1 imagem deste ano para o processamento.',
          addImage: 'ADICIONAR IMAGEM',
          discard: 'DESCARTAR',
          alreadyAdded: 'JÁ ADICIONADO',
          table: {
            id: 'ID',
            cloud: 'Nuvens',
            thumbnail: 'Miniatura',
            remove: 'Remove',
          },
          durationDays: {
            singular: 'dia',
            plural: 'dias',
          },
          durationMonths: {
            singular: 'mês',
            plural: 'meses',
          },
          durationYears: {
            singular: 'ano',
            plural: 'anos',
          },
          imageQuantity: {
            singular: 'imagem',
            plural: 'imagens',
          },
          selected: 'selecionadas',
          cloudPercentage: 'de nível de nuvens',
          undo: 'Limpar pontos',
          nextWarning: 'Selecione uma 1 imagem de cada ano para continuar',
        },
        5: {
          title: 'Classifique a cobertura do solo',
          description:
            'Desenhe as regiões dos tipos de cobertura do solo no mapa ou, se disponível, selecione uma fonte de dados com as informações de cobertura do solo.',
          cardText:
            'Considerando que o manguezal cresce em áreas que podem estar até 10 metros acima do nível do mar, o cálculo de compressão utiliza filtros de elevação do solo, com este valor sendo adotado como referência padrão.',
          confirm: 'CONFIRMAR',
          undo: 'Limpar',
          example: 'Exemplo',
          elevation: 'Elevação',
          withElevation: 'Elevação de 10 metros',
          noElevation: 'Sem filtro de elevação',
          defineElevation: 'Para definir um valor de elevação diferente do padrão altere o campo abaixo',
          labels: 'Legenda',
          labelsInfo: '*Numeros correspondem o codigo do tipo de solo.',
          availableDataset: 'DATASET DISPONÍVEL',
          availableDatasetText: 'Este ano possui uma coleção de dados de solo mapeada pelo',
          apply: 'Aplicar',
          defineLandCovers: 'SELECIONE O TIPO PARA DESENHAR NO MAPA',
          removePolygon: 'Remover forma',
          export: 'Exportar',
          import: 'Importar',
          importPolygons: 'IMPORTAR COORDENADAS DOS POLÍGONOS',
          formatImport: 'FORMATO CSV: código tipo de solo; lat1,lng1|lat2,lng2|...',
          spanImport: 'Após processar o arquivo, os poligonos aparecem automaticamente no mapa',
          toContinue: '*Defina polígonos de pelo menos duas classes diferentes para gerar a malha de classificação.',
          generate: 'GERAR RASTER',
          generateFailed: 'Não foi possível gerar o raster de classificação. Tente novamente.',
          confirmRaster: 'CONFIRME O RASTER GERADO',
          confirmRasterText:
            'Verifique o raster gerado no mapa. Se estiver satisfeito, e os raster de ambos os anos foram concluídos, o botão "CONTINUAR" será liberado.',
          editPolygons: 'EDITAR POLIGONOS',
          nextStepAlert: '*Na próxima etapa não será mais possível voltar para alterar datas, imagens ou o raster.',
          falseColor: 'Cor falsa',
          shortcut: 'ATALHO: É possível mover o mapa mantendo o botão CTRL pressionado.',
          nextWarning: 'Gere o raster dos dois anos para continuar',
          mapBiomasAlertTitle: 'Confirmar Aplicação do Dataset MapBiomas',
          mapBiomasAlertText:
            'Ao confirmar esta ação, o dataset do MapBiomas será aplicado no mapa e o raster será gerado. Todos os polígonos já desenhados serão descartados. Você pode apagar a classificação do MapBiomas e desenhar novos polígonos a qualquer momento clicando no botão "Editar Poligonos".',
          alertDialogConfirm: 'Confirmar',
          alertDialogCancel: 'Cancelar',
          alertDialogClose: 'Fechar',
          polygonsFileProcessed: 'Arquivo de polígonos processado e importado',
          drawingMode: 'Modo de Desenho',
          drawingModeText: 'Clique no mapa para desenhar retângulos do tipo ',
          drawingModeRemove: 'Modo de Remoção',
          drawingModeTextRemove: 'Clique no retângulo para removê-lo',
        },
        result: {
          steps: 'Etapas',
          polygons: 'Polígonos',
          baseLine: 'Linha base',
          drawBaseline: 'Desenhar linha de base',
          transect: 'Transecto',
          transectoinfo:
            'A cor dos transectos representa o nível de compressão do manguezal estimado pela análise. Selecione o número de anos para gerar a previsão, com base na classificação de uso e cobertura do solo.',
          transects: 'Transectos',
          visibilityController: 'Controlador de visibilidade',
          visibilityControllerDesc: '*As camadas do ano mais recente sobrepõem as camadas do ano mais antigo.',
          visibilityControllerinfo:
            'Neste painel, você pode visualizar as imagens de satélite selecionadas e o raster de classificação de uso do solo gerado na etapa anterior, habilitando cada camada pelo ícone de “olho”. A barra deslizante permite ajustar a transparência das camadas. Além disso, é possível exportar todas as imagens utilizadas ou produzidas na etapa anterior.',
          configTransects: 'Configurar transectos',
          calcule: 'Iniciar análise',
          stepsInfo:
            'Para realizar a análise de variação temporal e projeção futura, é necessário configurar os transectos de análise. Primeiro, desenhe uma linha-base sobre a qual os transectos serão criados. Em seguida, defina o espaçamento e a extensão entre eles. Não se esqueça de clicar no botão Iniciar Análise para executar o processamento.',
          tipBaseline: 'Para terminar o desenho você deve clicar duas vezes no mapa no ponto final da linha.',
          confirmBaseline: 'Deseja confirmar a linha ou redesenhar?',
          confirm: 'Confirmar',
          cancel: 'Cancelar',
          redo: 'Refazer',
          defineTransects: 'Defina a quantidade de transectos que serão desenhados pela linha base:',
          quantityTransects: 'Distância entre transectos (em metros)',
          lengthTransects: 'Tamanho (para cada lado em metros)',
          chartsTitle: 'Gráfico de evolução',

          transectResult: 'Resultado do Transecto',
          transectResultInfo:
            'Este painel mostra a evolução das áreas de cada classe de uso do solo para o transecto selecionado, considerando os dois anos de análise e a previsão escolhida. Para trocar de transecto, altere o número no topo do painel ou selecione-o diretamente no mapa.',
          loading: {
            wait: '*O processo pode demorar alguns minutos.',
            preparing: 'Preparando dados...',
            failed:
              'Não foi possível iniciar a análise dos transectos. Verifique se a área e as imagens classificadas foram carregadas e tente novamente.',
          },
          in: 'em',
          output: {
            noMangrove: 'Não há manguezal suficiente para o calulo deste transecto.',
            noHuman: 'Não há intervenção humana suficiente para o cálculo deste transecto.',
            thisTransect: 'neste transecto.',
            noSqueeze: 'Nenhum squeeze previsto',
            squeeze: 'Potencial de {number}% de squeeze',
            growth: 'Potencial de {number}% de crescimento',
            fullSqueeze: 'O potencial de squeeze é superior a 100%',
            organizeYear: 'Organizando dados de {year}...',
            calculatingTransect: 'Calculando transecto',
            calculatingComplete: '{year} finalizado...',
            ready: 'Análise completa',
          },
          forecast: 'Previsão',
          colorLegend: 'Legenda de cores',
          legend: {
            fullSqueeze: 'Squeeze avançado',
            moderateSqueeze: 'Squeeze moderado',
            noSqueeze: 'Manguezal estável',
            noMangrove: 'Manguezal insuficiente',
          },
          restart: 'Recomeçar',
          export: 'Exportar arquivo CSV',
          exportInfo:
            'Clique para exportar o arquivo CSV com os dados de área de cobertura do solo para os três anos de análise (os mesmos dados que compõem o painel anterior).',
          shp: 'Exportar Shapefile',
          shpInfo:
            'Clique para exportar os arquivos Shapefile contendo a linha de base e os transectos gerados pela análise.',
          id: 'ID',
          labels: {
            id: 'ID',
            0: 'MGV',
            1: 'VEG',
            2: 'HUM',
            3: 'WTR',
            4: 'PDA',
          },
        },
      },
      euscoast: {
        moduleName: 'EUSCoast',
        title: 'EUSCoast',
        prev: 'Voltar',
        next: 'Continuar',
        year: 'Ano',
        years: 'anos',
        landcovers: {
          mangrove: 'Manguezal',
          vegetation: 'Vegetação',
          water: "Corpo d'agua",
          human: 'Intervenção humana',
          beach: 'Praia, Duna e Areal',
          intertidal: 'Intermaré',
        },
        1: {
          title: 'Escolha o satélite',
          description: 'Selecione um dos satélites disponíveis para a aquisição de imagens.',
          card: {
            opticalResolution: 'Resolução ótica',
            opticalResolutionUnit: 'metros',
            activityPeriod: 'Período de atividade',
            provider: 'Fornecedor',
            revisitTime: 'Ciclo de captura',
            revisitTimeUnit: 'dias',
            choose: 'Escolher',
          },
        },
        2: {
          title: 'Defina a área de interesse',
          description: 'Delimite a área de interesse utilizando o mapa abaixo.',
          showDelimiters: ' delimitadores',
          undo: 'Desfazer',
          processFile: 'Processar arquivo',
          importLegend: 'Importe a área de interesse por meio de um arquivo KML:',
          importTitle: 'Importar KML',
          aoiFileTitle: 'Área de interesse',
          fileLabel: 'Arquivo:',
          noKmlFileSelected: 'Nenhum arquivo KML selecionado.',
          aoiLoadedOnMap: 'Área de interesse carregada no mapa.',
          drawOnMapOrImportKml: 'Desenhe no mapa ou importe um arquivo KML.',
          example: 'Exemplos podem ser baixados aqui',
          dataTrainning: 'Dados de treino',
          dataTrainningLegend: 'Importe o arquivo de treino',
          dataTrainningFileLabel: 'Informe a data do arquivo de treino:',
          dataTrainningDateHint:
            '*Utilize um arquivo com nome encerrando com _ddmmyyyy.csv para ter a data de treino preenchida automatiamente.',
          bathymetryDescription: 'Defina a área de interesse e o arquivo de treino para continuar.',
          labelBathymetryStep: 'Defina a área de interesse e dados de treino',
          helpCoordinateSystem:
            'Por padrão o CASSIE interpreta as coordenadas com o sistema EPSG:4326 (WGS84 - Coordenadas Geográficas).\nMas caso o seu arquivo de treino esteja baseado em outro sistema de coordenadas EPSG,\nvocê pode digitar o código do seu sistema, que o CASSIE irá fazer a devida interpretação dos dados.',
          performanceMessage: 'A área marcada possui {number} km² e terá um desempenho {level} durante os cálculos.',
          slow: 'lento',
          moderate: 'moderado',
          fast: 'rápido',
          geeError: {
            title: 'Aviso de Erro!',
            content:
              'Parece que a sua conta ainda não está autorizada a usar as ferramentas do Google Earth Engine. Você precisa completar seu registro através deste link: ',
            close: 'Fechar',
          },
          errorTitle: 'Mensagem de erro',
          errorMessageSelectFile: 'Por favor, selecione um arquivo primeiro.',
          errorMessageDrawingOutline: 'Por favor, selecione um arquivo primeiro.',
          errorMessageNoValidCoord: 'Nenhuma coordenada válida foi encontrada no arquivo KML.',
          errorMessageUnableInterpretKml: 'Não foi possível interpretar o arquivo KML.',
          infoTitle: 'Mensagem informativa',
          infoMessageSuccess: 'Arquivo KML processado com sucesso.',
          close: 'Fechar',
        },
        3: {
          title: 'Seleção de imagens - 1',
          description:
            'Visualize as imagens e adicione-as a lista.\n Ao selecionar mais de uma imagem por período, será gerada uma imagem mediana final.\n Imagens com nuvens terão aplicação de filtro de remoção',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          durationDays: {
            singular: 'dia',
            plural: 'dias',
          },
          durationMonths: {
            singular: 'mês',
            plural: 'meses',
          },
          durationYears: {
            singular: 'ano',
            plural: 'anos',
          },
          imageQuantity: {
            singular: 'imagem',
            plural: 'imagens',
          },
          cloudPercentage: 'Nível de nuvens',
        },
        4: {
          title: 'Seleção de imagens - 2',
          description:
            'Visualize as imagens e adicione-as a lista.\n Ao selecionar mais de uma imagem por período, será gerada uma imagem mediana final.\n Imagens com nuvens terão aplicação de filtro de remoção',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          with: 'com',
          tabText: 'Selecione as datas disponíveis na barra clicando nos pontos rosas abaixo:',
          emptyImages: 'Nenhuma imagem encontrada com essa porcentagem de nuvens.',
          viewImage: 'Visualizar imagem',
          listText: '*Selecione ao menos 1 imagem deste ano para o processamento.',
          addImage: 'ADICIONAR IMAGEM',
          discard: 'DESCARTAR',
          alreadyAdded: 'JÁ ADICIONADO',
          table: {
            id: 'ID',
            cloud: 'Nuvens',
            thumbnail: 'Miniatura',
            remove: 'Remove',
          },
          durationDays: {
            singular: 'dia',
            plural: 'dias',
          },
          durationMonths: {
            singular: 'mês',
            plural: 'meses',
          },
          durationYears: {
            singular: 'ano',
            plural: 'anos',
          },
          imageQuantity: {
            singular: 'imagem',
            plural: 'imagens',
          },
          selected: 'selecionadas',
          cloudPercentage: 'de nível de nuvens',
          undo: 'Limpar pontos',
          nextWarning: 'Selecione uma 1 imagem de cada ano para continuar',
        },
        5: {
          title: 'Classifique a cobertura do solo',
          description:
            'Desenhe as regiões dos tipos de cobertura do solo no mapa ou, se disponível, selecione uma fonte de dados com as informações de cobertura do solo.',
          confirm: 'CONFIRMAR',
          undo: 'Limpar',
          example: 'Exemplo',
          labels: 'Legenda',
          labelsInfo: '*Numeros correspondem o codigo do tipo de solo.',
          availableDataset: 'DATASET DISPONÍVEL',
          availableDatasetText: 'Este ano possui uma coleção de dados de solo mapeada pelo',
          apply: 'Aplicar',
          defineLandCovers: 'SELECIONE O TIPO PARA DESENHAR NO MAPA',
          removePolygon: 'Remover forma',
          export: 'Exportar',
          import: 'Importar',
          importPolygons: 'IMPORTAR COORDENADAS DOS POLÍGONOS',
          formatImport: 'FORMATO CSV: código tipo de solo; lat1,lng1|lat2,lng2|...',
          spanImport: 'Após processar o arquivo, os poligonos aparecem automaticamente no mapa',
          toContinue: '*Defina polígonos de pelo menos duas classes diferentes para gerar a malha de classificação.',
          generate: 'GERAR RASTER',
          generateFailed: 'Não foi possível gerar o raster de classificação. Tente novamente.',
          confirmRaster: 'CONFIRME O RASTER GERADO',
          confirmRasterText:
            'Verifique o raster gerado no mapa. Se estiver satisfeito, e os raster de ambos os anos foram concluídos, o botão "CONTINUAR" será liberado.',
          editPolygons: 'EDITAR POLIGONOS',
          nextStepAlert: '*Na próxima etapa não será mais possível voltar para alterar datas, imagens ou o raster.',
          falseColor: 'Cor falsa',
          shortcut: 'ATALHO: É possível mover o mapa mantendo o botão CTRL pressionado.',
          nextWarning: 'Gere o raster dos dois anos para continuar',
          mapBiomasAlertTitle: 'Confirmar Aplicação do Dataset MapBiomas',
          mapBiomasAlertText:
            'Ao confirmar esta ação, o dataset do MapBiomas será aplicado no mapa e o raster será gerado. Todos os polígonos já desenhados serão descartados. Você pode apagar a classificação do MapBiomas e desenhar novos polígonos a qualquer momento clicando no botão "Editar Poligonos".',
          alertDialogConfirm: 'Confirmar',
          alertDialogCancel: 'Cancelar',
          alertDialogClose: 'Fechar',
          polygonsFileProcessed: 'Arquivo de polígonos processado e importado',
          drawingMode: 'Modo de Desenho',
          drawingModeText: 'Clique no mapa para desenhar retângulos do tipo ',
          drawingModeRemove: 'Modo de Remoção',
          drawingModeTextRemove: 'Clique no retângulo para removê-lo',
        },
        result: {
          returnToLastStep: 'Voltar para a última etapa',
          returnToBegin: 'Voltar à seleção de módulos',
          steps: 'Etapas',
          polygons: 'Polígonos',
          baseLine: 'Linha base',
          drawBaseline: 'Desenhar linha de base',
          transect: 'Transecto',
          transectoinfo:
            'A cor dos transectos representa o potencial de expansão da área urbana estimado pela análise. Selecione o número de anos para gerar a previsão, com base na classificação de uso e cobertura do solo.',
          transects: 'Transectos',
          visibilityController: 'Controlador de visibilidade',
          visibilityControllerDesc: '*As camadas do ano mais recente sobrepõem as camadas do ano mais antigo.',
          visibilityControllerinfo:
            'Neste painel, você pode visualizar as imagens de satélite selecionadas e o raster de classificação de uso do solo gerado na etapa anterior, habilitando cada camada pelo ícone de “olho”. A barra deslizante permite ajustar a transparência das camadas. Além disso, é possível exportar todas as imagens utilizadas ou produzidas na etapa anterior.',
          configTransects: 'Configurar transectos',
          calcule: 'Iniciar análise',
          stepsInfo:
            'Para realizar a análise de variação temporal e projeção futura, é necessário configurar os transectos de análise. Primeiro, desenhe uma linha-base sobre a qual os transectos serão criados. Em seguida, defina o espaçamento e a extensão entre eles. Não se esqueça de clicar no botão Iniciar Análise para executar o processamento.',
          tipBaseline: 'Para terminar o desenho você deve clicar duas vezes no mapa no ponto final da linha.',
          confirmBaseline: 'Deseja confirmar a linha ou redesenhar?',
          confirm: 'Confirmar',
          cancel: 'Cancelar',
          redo: 'Refazer',
          defineTransects: 'Defina a quantidade de transectos que serão desenhados pela linha base:',
          quantityTransects: 'Distância entre transectos (em metros)',
          lengthTransects: 'Tamanho (para cada lado em metros)',
          chartsTitle: 'Gráfico de evolução',

          transectResult: 'Resultado do Transecto',
          transectResultInfo:
            'Este painel mostra a evolução das áreas de cada classe de uso do solo para o transecto selecionado, considerando os dois anos de análise e a previsão escolhida. Para trocar de transecto, altere o número no topo do painel ou selecione-o diretamente no mapa.',
          loading: {
            wait: '*O processo pode demorar alguns minutos.',
            preparing: 'Preparando dados...',
            failed:
              'Não foi possível iniciar a análise dos transectos. Verifique se a área e as imagens classificadas foram carregadas e tente novamente.',
          },
          in: 'em',
          output: {
            noUrban: 'Não há área urbana suficiente para o cálculo deste transecto.',
            thisTransect: 'neste transecto.',
            stable: 'Nenhum crescimento urbano previsto',
            moderateGrowth: 'Potencial de {number}% de expansão urbana',
            advancedGrowth: 'Potencial de {number}% de expansão urbana (crescimento avançado)',
            organizeYear: 'Organizando dados de {year}...',
            calculatingTransect: 'Calculando transecto',
            calculatingComplete: '{year} finalizado...',
            ready: 'Análise completa',
          },
          forecast: 'Previsão',
          colorLegend: 'Legenda de cores',
          legend: {
            advancedGrowth: 'Crescimento avançado',
            moderateGrowth: 'Crescimento moderado',
            stable: 'Área urbana estável',
            noUrban: 'Área urbana insuficiente',
          },
          restart: 'Recomeçar',
          export: 'Exportar arquivo CSV',
          exportInfo:
            'Clique para exportar o arquivo CSV com os dados de área de cobertura do solo para os três anos de análise (os mesmos dados que compõem o painel anterior).',
          shp: 'Exportar Shapefile',
          shpInfo:
            'Clique para exportar os arquivos Shapefile contendo a linha de base e os transectos gerados pela análise.',
          vector: 'Exportar raster como vetor',
          vectorInfo:
            'Clique para exportar a classificação de cobertura do solo vetorizada (um Shapefile de polígonos por ano, com o ano, o código e o nome de cada classe), pronta para ser aberta no QGIS.',
          id: 'ID',
          labels: {
            id: 'ID',
            0: 'MGV',
            1: 'VEG',
            2: 'HUM',
            3: 'WTR',
            4: 'PDA',
          },
        },
      },
      mepbay: {
        moduleName: 'MepBay',
        title: 'MepBay',
        prev: 'Voltar',
        next: 'Continuar',
        year: 'Ano',
        years: 'anos',
        periodAndImages: {
          title: 'Período e imagens',
          description:
            'Ajuste o período e o filtro de nuvens e escolha as imagens que deseja utilizar. Você pode reajustar o período quantas vezes quiser, sem sair desta etapa.',
        },
        1: {
          title: 'Defina a área de interesse',
          description: 'Delimite a área de interesse utilizando o mapa abaixo.',
          showDelimiters: ' delimitadores',
          undo: 'Desfazer',
          processFile: 'Processar arquivo',
          importLegend: 'Importe a área de interesse por meio de um arquivo KML:',
          importTitle: 'Importar KML',
          bathymetryDescription: 'Defina a área de interesse e o arquivo de treino para continuar.',
          labelBathymetryStep: 'Defina a área de interesse e dados de treino',
          helpCoordinateSystem:
            'Por padrão o CASSIE interpreta as coordenadas com o sistema EPSG:4326 (WGS84 - Coordenadas Geográficas).\nMas caso o seu arquivo de treino esteja baseado em outro sistema de coordenadas EPSG,\nvocê pode digitar o código do seu sistema, que o CASSIE irá fazer a devida interpretação dos dados.',
          performanceMessage: 'A área marcada possui {number} km² e terá um desempenho {level} durante os cálculos.',
          slow: 'lento',
          moderate: 'moderado',
          fast: 'rápido',
          geeError: {
            title: 'Aviso de Erro!',
            content:
              'Parece que a sua conta ainda não está autorizada a usar as ferramentas do Google Earth Engine. Você precisa completar seu registro através deste link: ',
            close: 'Fechar',
          },
          errorTitle: 'Mensagem de erro',
          errorMessageSelectFile: 'Por favor, selecione um arquivo primeiro.',
          errorMessageDrawingOutline: 'Por favor, selecione um arquivo primeiro.',
          errorMessageNoValidCoord: 'Nenhuma coordenada válida foi encontrada no arquivo KML.',
          errorMessageUnableInterpretKml: 'Não foi possível interpretar o arquivo KML.',
          infoTitle: 'Mensagem informativa',
          infoMessageSuccess: 'Arquivo KML processado com sucesso.',
          close: 'Fechar',
        },
        2: {
          title: 'Defina os periodos',
          description: 'Selecione dois anos para obter as imagens',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          durationDays: { singular: 'dia', plural: 'dias' },
          durationMonths: { singular: 'mês', plural: 'meses' },
          durationYears: { singular: 'ano', plural: 'anos' },
          imageQuantity: { singular: 'imagem', plural: 'imagens' },
          cloudPercentage: 'Nível de nuvens',
        },
        3: {
          title: 'Selecione as imagens',
          description:
            'Visualize as imagens e adicione-as na lista. \n (Imagens com nuvens terão um filtro de remoção aplicado)',
          loading: 'Carregando...',
          period: 'Período',
          to: 'a',
          with: 'com',
          tabText: 'Selecione as datas disponíveis na barra clicando nos pontos rosas abaixo:',
          emptyImages: 'Nenhuma imagem encontrada com esta porcentagem de nuvens.',
          viewImage: 'Visualizar imagem',
          listText: '*Selecione ao menos 1 imagem deste ano para o processamento.',
          addImage: 'ADICIONAR IMAGEM',
          discard: 'DESCARTAR',
          alreadyAdded: 'JÁ ADICIONADA',
          table: {
            id: 'ID',
            cloud: 'Nuvens',
            thumbnail: 'Miniatura',
            remove: 'Remover',
          },
          durationDays: { singular: 'dia', plural: 'dias' },
          durationMonths: { singular: 'mês', plural: 'meses' },
          durationYears: { singular: 'ano', plural: 'anos' },
          imageQuantity: { singular: 'imagem', plural: 'imagens' },
          selected: 'selecionada',
          cloudPercentage: 'de nível de nuvens',
          undo: 'Limpar pontos',
          nextWarning: 'Selecione 1 imagem de cada ano para continuar',
        },
        4: {
          title: 'Classificar cobertura do solo',
          helpTooltip: 'Clique para ver ajuda sobre as camadas',
          helpTitle: 'Como classificar a cobertura do solo',
          helpContent:
            'Para gerar o modelo parabólico, você deve primeiro criar uma nova camada. Essa camada armazenará os pontos de controle e a curva resultante. Após criar a camada, siga estas três etapas: 1. Ponto de Difração – Representa o local onde a onda começa a contornar a costa. 2. Ponto de Fechamento – Indica o final do trecho da costa analisado. 3. Ponto de Tangência – Define a direção predominante da onda e ajuda a moldar a curva. Clique em cada etapa na ordem indicada e siga as instruções para selecionar o local correto. Após marcar os três pontos, o modelo será calculado automaticamente.',
          description:
            'Desenhe as regiões dos tipos de cobertura de solo no mapa ou, se disponível, selecione uma fonte de dados com informações de cobertura do solo.',
          cardText:
            'Considerando que os mangues crescem em áreas que podem estar até 10 metros acima do nível do mar, o cálculo de compressão utiliza filtros de elevação do solo, sendo este valor adotado como referência padrão.',
          confirm: 'CONFIRMAR',
          undo: 'Limpar',
          example: 'Exemplo',
          elevation: 'Elevação',
          withElevation: 'Elevação de 10 metros',
          noElevation: 'Sem filtro de elevação',
          defineElevation: 'Para definir um valor de elevação diferente do padrão, altere o campo abaixo',
          labels: 'Legenda',
          labelsInfo: '*Números correspondem ao código do tipo de cobertura do solo.',
          availableDataset: 'DATASET DISPONÍVEL',
          availableDatasetText: 'Este ano possui uma coleção de dados de solo mapeado por',
          apply: 'Aplicar',
          defineLandCovers: 'SELECIONE O TIPO PARA DESENHAR NO MAPA',
          removePolygon: 'Remover forma',
          export: 'Exportar',
          import: 'Importar',
          importPolygons: 'IMPORTAR COORDENADAS DOS POLÍGONOS',
          formatImport: 'FORMATO CSV: código de cobertura do solo; lat1,lng1|lat2,lng2|...',
          spanImport: 'Após o processamento do arquivo, os polígonos aparecerão automaticamente no mapa',
          toContinue: '*Defina polígonos de pelo menos duas classes diferentes para gerar a grade de classificação.',
          generate: 'GERAR RASTER',
          confirmRaster: 'CONFIRMAR RASTER GERADO',
          confirmRasterText:
            'Verifique o raster gerado no mapa. Se satisfeito, e ambos os rasters dos anos estiverem completos, o botão "CONTINUAR" será habilitado.',
          editPolygons: 'EDITAR POLÍGONOS',
          nextStepAlert: '*No próximo passo não será mais possível voltar para alterar datas, imagens ou o raster.',
          falseColor: 'Cor falsa',
          shortcut: 'ATALHO: Você pode mover o mapa segurando o botão CTRL.',
          nextWarning: 'Gere o raster para ambos os anos para continuar',
          mapBiomasAlertTitle: 'Confirmar Aplicação do Dataset MapBiomas',
          mapBiomasAlertText:
            'Ao confirmar esta ação, o dataset MapBiomas será aplicado no mapa e o raster será gerado. Todos os polígonos previamente desenhados serão descartados. Você pode apagar a classificação MapBiomas e desenhar novos polígonos a qualquer momento clicando no botão "Editar Polígonos".',
          alertDialogConfirm: 'Confirmar',
          alertDialogCancel: 'Cancelar',
          alertDialogClose: 'Fechar',
          polygonsFileProcessed: 'Arquivo de polígonos processado e importado',
          drawingMode: 'Modo de Desenho',
          drawingModeText: 'Clique no mapa para desenhar retângulos do tipo ',
          drawingModeRemove: 'Modo de Remoção',
          drawingModeTextRemove: 'Clique no retângulo para removê-lo',
        },

        result: {
          layers: 'Ver Camadas',
          steps: 'Etapas',
          polygons: 'Polígonos',
          baseLine: 'Linha de base',
          drawBaseline: 'Desenhar linha de base',
          transect: 'Transecto',
          transectoinfo:
            'A cor dos transectos representa o nível de compressão do manguezal estimado. Selecione o número de anos para gerar a previsão, com base na classificação de uso e cobertura do solo.',
          transects: 'Transectos',
          visibilityController: 'Controlador de visibilidade',
          visibilityControllerDesc: '*As camadas do ano mais recente se sobrepõem às camadas do ano mais antigo.',
          configTransects: 'Configurar transectos',
          calcule: 'Iniciar análise',
          tipBaseline: 'Para finalizar o desenho, você deve dar um duplo clique no mapa no ponto final da linha.',
          confirmBaseline: 'Deseja confirmar a linha ou redesenhá-la?',
          confirm: 'Confirmar',
          cancel: 'Cancelar',
          redo: 'Refazer',
          defineTransects: 'Defina o número de transectos a serem desenhados a partir da linha de base:',
          quantityTransects: 'Quantidade (aproximada)',
          lengthTransects: 'Tamanho (para cada lado em metros)',
          chartsTitle: 'Gráfico de evolução',
          transectResult: 'Resultado do Transecto',
          transectResultInfo:
            '2. Este painel mostra a evolução das áreas de uso e cobertura do solo para o transecto selecionado, considerando os dois anos de análise e a previsão escolhida. Para trocar de transecto, altere o número no topo do painel ou selecione-o diretamente no mapa.',
          loading: {
            wait: '*O processo pode levar alguns minutos.',
            preparing: 'Preparando dados...',
          },
          in: 'em',
          output: {
            thisTransect: 'neste transecto.',
            organizeYear: 'Organizando dados de {year}...',
            calculatingTransect: 'Calculando transecto',
            calculatingComplete: '{year} concluído...',
            ready: 'Análise completa',
          },
          forecast: 'Previsão',
          restart: 'Reiniciar',
          export: 'Exportar arquivo CSV',
          shp: 'Exportar Shapefile',
          exportSessionState: 'Exportar sessão para teste',
          labels: {
            id: 'ID',
            0: 'MGV',
            1: 'VEG',
            2: 'HUM',
            3: 'WTR',
          },
          // MepBay specific translations
          layerName: 'Camada',
          auxiliaryPoint: 'Ponto Auxiliar',
          diffractionPoint: 'Ponto de Difração',
          closurePoint: 'Ponto de Fechamento',
          tangentPoint: 'Ponto Tangente',
          selectDiffractionPoint: 'Selecione o ponto de difração (geometria2)',
          selectClosurePoint: 'Selecione o ponto de fechamento da praia (geometria3)',
          selectTangentPoint: 'Selecione o ponto tangente à linha de costa (geometria4)',
          manageLayers: 'Gerenciar Camadas',
          viewAndExportData: 'Visualizar mapas selecionados',
          viewAndExportDataInfo:
            'Essa seleção  exibe as imagens de satélite que foram previamente selecionadas durante a etapa de escolha de datas.',
          noLayersAvailable: 'Nenhuma camada disponível',
          dataAvailable: 'Dados disponíveis',
          incomplete: 'Incompleto',
          viewDetailsAndExport: 'Ver Detalhes e Exportar',
          createNewLayer: 'Criar Nova Camada',
          createNewLayerInfo:
            'Criar uma nova camada é o primeiro passo para iniciar a modelagem parabólica. Essa camada serve como um espaço dedicado para armazenar os pontos de controle e os resultados gerados durante o processo. Ao manter os dados organizados em camadas separadas, você garante mais clareza, controle e flexibilidade na análise costeira.',
          activeLayerInfo: 'Informações da Camada Ativa',
          completed: 'Concluído',
          selecting: 'Selecionando...',
          available: 'Disponível',
          blocked: 'Bloqueado',
          resetActiveLayer: 'Resetar Camada Ativa',
          chooseLayerColor: 'Escolher Cor da Camada',
          detailsAndExport: 'Detalhes e Exportação',
          exportSatelliteImages: 'Exportar imagens de satélites',
          coefficientsAndParameters: 'Coeficientes e Parâmetros',
          betaAngle: 'Ângulo Beta',
          thetaRadiusTable: 'Tabela Theta e Raio',
          theta: 'Theta',
          radius: 'Raio',
          noLineFound: 'Nenhuma linha encontrada na camada ativa para exportação.',
          couldNotCalculateBounds: 'Não foi possível calcular os limites da área para exportação.',
          errorExportingTiff: 'Erro ao exportar mapa como TIFF:',
          errorDetails: 'Detalhes do erro:',
          errorExportingImage: 'Erro ao exportar imagem. Por favor, tente novamente.',
          errorCalculatingModel: 'Erro ao calcular modelo parabólico:',
          errorUsingTurf: 'Erro ao usar Turf.js:',
          anglesNotEqual: 'Ângulos Beta não são iguais. Código foi interrompido.',
          calculating: 'Calculando...',
          csvHeader: 'Camada,Data',
          thetaRadiusHeader: 'Theta,Raio',
          legendTitle: 'Legenda - Modelo MepBay',
          legendDiffractionPoint: 'Ponto de difração (1)',
          legendClosurePoint: 'Ponto de controle costeiro (2)',
          legendTangentPoint: 'Direção predominante das ondas (3)',
          legendControlLine: 'Linha de controle (Ro)',
          legendParabolicLine: 'Linha parabólica: forma estatística da praia (baía)',
        },
      },
      shoreS: {
        moduleName: 'Shore-S',
        acquisition: {
          title: 'SHORE-S',
          0: {
            title: 'Selecione a ferramenta',
            description: 'Inicie o módulo SHORE-S ou acesse a documentação.',
          },
          1: {
            description: 'Selecione a fonte de dados para a aquisição de imagens.',
          },
          2: {
            title: 'Dados modelados',
            header: 'SHORE-S: Upload de Dados Modelados',
            description: 'Defina o sistema de coordenadas e faça upload dos resultados do modelo.',
          },
          periodAndImages: {
            title: 'Período e imagens',
            description:
              'Ajuste o período e o filtro de nuvens e escolha as imagens que deseja utilizar. Você pode reajustar o período quantas vezes quiser, sem sair desta etapa.',
          },
          entry: {
            moduleCard: 'Módulo SHORE-S',
            moduleCardDesc: 'Validação de resultados de Modelagem de Linha de Costa.',
            docsCard: 'Documentação',
            docsCardDesc:
              'Acesse o modelo sedimentar ShorelineS (Roelvink et al, 2020) em matlab ou adaptado para python.',
          },
          dataChooser: {
            crsLabel: 'Sistema de Coordenadas (CRS)',
            crsPlaceholder: 'Ex: EPSG:32722',
            modeledDataTitle: 'Resultados do Modelo',
            modelFileLabel: 'Saída do modelo',
            modelFileHintMat:
              'MATfile: A saída do modelo sedimentar ShorelineS é diretamente compatível com a aplicação.',
            modelFileHintCsv:
              'CSVs: Um arquivo contendo as variáveis "tempo", "x" e "y", em que cada linha representa um ponto da linha de costa no tempo.',
            exampleCsv: 'Exemplo CSV — Saída do modelo',
            restoredFileName: 'Arquivo carregado anteriormente',
            parsingModel: 'Lendo arquivo do modelo…',
            parseError: 'Não foi possível interpretar o arquivo selecionado.',
            temporalDetectedHint: 'Intervalo temporal detectado:',
            temporalDetectedSeparator: 'até',
            dateLimitHint: 'Ajuste permitido: {{min}} a {{max}} (até {{months}} meses além do período do modelo).',
            dateErrorTitle: 'Período fora do limite permitido',
            dateErrorStartOutOfRange:
              'A data de início ({{value}}) está fora do intervalo permitido: {{min}} a {{max}} (até {{months}} meses além do período do modelo).',
            dateErrorEndOutOfRange:
              'A data de término ({{value}}) está fora do intervalo permitido: {{min}} a {{max}} (até {{months}} meses além do período do modelo).',
            dateErrorStartAfterEnd: 'A data de início não pode ser posterior à data de término.',
            dateErrorFieldHelper: 'Fora do limite permitido ({{min}} a {{max}}).',
            dateStartLabel: 'Data de início',
            dateEndLabel: 'Data de término',
            noTemporalData: 'Este modelo não possui dados temporais — o fluxo seguirá direto para a reprojeção.',
            mapLegendTitle: 'Legenda:',
            mapLegendCoastlines: 'Linhas de Costa Modeladas',
            mapLegendRoi: 'Área de Interesse (AOI)',
          },
          periodChooser: {
            userDatesLabel: 'Utilizar datas informadas pelo usuário?',
            cloudFilterLabel: 'Cobertura máxima de nuvens (%)',
            noImages: 'Nenhuma imagem encontrada no período selecionado.',
            noRoi:
              'Área de interesse não definida. Volte à tela anterior e verifique se o arquivo do modelo foi processado corretamente.',
            loadingMore: 'Buscando imagens do período adicional…',
          },
          imageSelector: {
            listPlaceholder: 'Nenhuma imagem disponível — volte e ajuste o período ou o filtro de nuvens.',
          },
        },
        merge: {
          toleranceLabel: 'Tolerância Temporal (dias)',
          directionLabel: 'Direção de Busca',
          directionForward: 'Adiante',
          directionBackward: 'Atrás',
          directionNearest: 'Mais próximo',
          help: {
            tooltip: 'Sobre os parâmetros',
            title: 'Parâmetros',
            intro: 'Parâmetros definem como os dados modelados serão associados às observações para o cálculo do erro.',
            tolerance:
              'Tolerância temporal: define o intervalo máximo de tempo, em relação à data de cada observação, dentro do qual uma data modelada poderá ser selecionada para o pareamento.',
            direction: 'Direção da busca: define como a data modelada será procurada em relação à data da observação:',
            forward: '• Adiante: busca a data modelada posterior mais próxima dentro da tolerância.',
            backward: '• Atrás: busca a data modelada anterior mais próxima dentro da tolerância.',
            nearest:
              '• Mais próximo: busca a data modelada mais próxima dentro da tolerância nas duas direções, anterior ou posterior à observação.',
          },
        },
        analysis: {
          title: 'Validação dos Dados Modelados',
          help: {
            title: 'Validação dos Dados Modelados',
            intro:
              'Para iniciar a análise, é necessário desenhar a linha de base ao longo da costa e configurar os transectos.',
            config:
              'A configuração inclui a definição da distância entre os transectos e o tamanho (comprimento) de cada transecto.',
            purpose:
              'Essa geometria será utilizada para interseccionar os dados modelados e observados, de modo a possibilitar o cálculo de erro entre eles.',
          },
          execute: 'Executar análise',
          cleaning: 'Pareando Dados Modelados e Observados',
          metricsTitle: 'Métricas de erro',
          metrics: {
            modelSection: 'Erro da simulação (Modelado × Referência)',
            measuredSection: 'Variância observada no período (Final × Inicial)',
            unit: 'm',
            rmseAvg: {
              label: 'RMSE Médio da Simulação',
            },
            biasAvg: {
              label: 'Viés Médio da Simulação',
            },
            rmseLast6m: {
              label: 'RMSE (últimos 6 meses)',
            },
            rmseFinal: {
              label: 'RMSE (final)',
            },
            biasFinal: {
              label: 'Viés (final)',
            },
            rmsm: {
              label: 'RMS medido',
            },
            biasm: {
              label: 'Viés medido',
            },
            bss: {
              label: 'Brier Skill Score (BSS)',
              bad: 'Ruim',
              poor: 'Fraco',
              reasonable: 'Razoável',
              good: 'Bom',
              excellent: 'Excelente',
            },
          },
          togglePlots: 'Abrir plots',
          plotByDateTitle: 'Erro médio ao longo do tempo',
          plotByTransectTitle: 'Erro médio por transecto',
          plotDateAxis: 'Data',
          plotTransectAxis: 'ID do transecto',
          plotTransectShort: 'Transecto',
          plotErrorAxis: 'Erro (m)',
          plotRmsSeries: 'RMSE',
          plotBiasSeries: 'Viés',
          plotExportImage: 'Exportar como imagem',
        },
        exports: {
          title: 'Exportar resultados',
          pairs: 'Pares modelado × referência (CSV)',
          metrics: 'Resumo das métricas de erro (CSV)',
          baselineKml: 'Linha de base (KML)',
          baselineFolder: 'Linha de Base',
          downloadCsv: 'Baixar',
        },
        map: {
          noModelTitle: 'Nenhum modelo carregado',
          noModelMessage:
            'As linhas de costa modeladas não estão disponíveis — a página pode ter sido recarregada ou aberta diretamente. Volte ao início e carregue o arquivo do modelo novamente.',
          placeholder: 'Tela de visualização das linhas de costa modeladas e de referência.',
          legendModeled: 'Linhas de Costa Modeladas',
          legendReference: 'Linhas de Costa de Referência',
          legendRaw: 'Linhas de Costa Extraídas',
        },
        extraction: {
          title: 'Extração das linhas de costa',
          running: 'Extraindo das imagens de satélite…',
          ready: '{{extracted}} de {{requested}} imagens processadas.',
          retry: 'Tentar novamente',
          waitingTooltip: 'Aguarde a extração das linhas de costa terminar.',
        },
      },
    },
  },
};

export default pt;
